import React, { useCallback, useState, useEffect, useRef } from 'react';
import { obterListaCompleta50Cromos } from './cadernetaConfig';
import { db, auth } from './firebase';
import { doc, collection, addDoc, updateDoc, setDoc, increment, onSnapshot, getDoc, serverTimestamp, query, orderBy, limit } from 'firebase/firestore';
import AgoraRTC from "agora-rtc-sdk-ng";
import { enviarNotificacao } from './notificacoesService'; // Teu serviço real de torpedos
import { AGORA_APP_ID } from './agora-config';
import JanelaRankingLive from './JanelaRankingLive';
import { useSessaoAgora } from './useSessaoAgora';
import EstadoLigacaoEstadio from './EstadoLigacaoEstadio';
import { reproduzirVideoNoContentor } from './agoraSession';
import PopupAtualizacaoEstadio from './PopupAtualizacaoEstadio';
import { shouldShowStadiumUpdate, markStadiumUpdateShown } from './stadiumUpdate';
import { moverSaldo } from './saldoUtilizador';
import { adicionarXP } from './tabelaNiveis';
import { obterImagemAdepto, obterImagemJogador } from './tabelaNiveis';

import imgfundoAudio from './assets/fundos/fundoAudio.webp';
import CadernetaGaleria from './CadernetaGaleria';

// IMPORTAÇÃO DOS PRESENTES REAIS
// 1. IMPORTAÇÕES (Tudo em minúsculas como na tua pasta)
// ==========================================
// LISTA MESTRE DE PRESENTES PREMIUM (50 FUTEBOL)
// ==========================================

// Bloco Novos Presentes (Futebol)
// Bloco 1 (150 Moedas)
import imgGift90Minutos from './assets/presentes/miniaturas/gift_90_minutos.webp';
import vidGift90Minutos from './assets/presentes/leves/gift_90_minutos.webm';

import imgGiftAnelCampeao from './assets/presentes/miniaturas/gift_anel_de_campeao.webp';
import vidGiftAnelCampeao from './assets/presentes/leves/gift_anel_de_campeao.webm';
import PresenteTransparente from './PresenteTransparente';
import { videoSemFundo } from './presentesSemFundo';
import { useAquecerPresentes } from './useAquecerPresentes';

import imgGiftApito from './assets/presentes/miniaturas/gift_apito.webp';
import vidGiftApito from './assets/presentes/leves/gift_apito.webm';

import imgGiftBaliza from './assets/presentes/miniaturas/gift_baliza.webp';
import vidGiftBaliza from './assets/presentes/leves/gift_baliza.webm';

import imgGiftBancadaVip from './assets/presentes/miniaturas/gift_bancada_vip.webp';
import vidGiftBancadaVip from './assets/presentes/leves/gift_bancada_vip.webm';

import imgGiftBancoSuplentes from './assets/presentes/miniaturas/gift_banco_de_suplentes.webp';
import vidGiftBancoSuplentes from './assets/presentes/leves/gift_banco_de_suplentes.webm';

import imgGiftBandeiraClaque from './assets/presentes/miniaturas/gift_bandeira_da_claque.webp';
import vidGiftBandeiraClaque from './assets/presentes/leves/gift_bandeira_da_claque.webm';

import imgGiftBandeirolaCanto from './assets/presentes/miniaturas/gift_bandeirola_de_canto.webp';
import vidGiftBandeirolaCanto from './assets/presentes/leves/gift_bandeirola_de_canto.webm';

import imgGiftBolaOuro from './assets/presentes/miniaturas/gift_bola_de_ouro.webp';
import vidGiftBolaOuro from './assets/presentes/leves/gift_bola_de_ouro.webm';

import imgGiftBolaChamas from './assets/presentes/miniaturas/gift_bola_em_chamas.webp';
import vidGiftBolaChamas from './assets/presentes/leves/gift_bola_em_chamas.webm';

// Bloco Novos Presentes - Grupo 2 (Futebol)
import imgGiftBotaDiamante from './assets/presentes/miniaturas/gift_bota_de_diamante.webp';
import vidGiftBotaDiamante from './assets/presentes/leves/gift_bota_de_diamante.webm';

import imgGiftBrasao from './assets/presentes/miniaturas/gift_brasao.webp';
import vidGiftBrasao from './assets/presentes/leves/gift_brasao.webm';

import imgGiftCachecol from './assets/presentes/miniaturas/gift_cachecol.webp';
import vidGiftCachecol from './assets/presentes/leves/gift_cachecol.webm';

import imgGiftCaneleiras from './assets/presentes/miniaturas/gift_caneleiras.webp';
import vidGiftCaneleiras from './assets/presentes/leves/gift_caneleiras.webm';

import imgGiftCanhaoCamisolas from './assets/presentes/miniaturas/gift_canhao_de_camisolas.webp';
import vidGiftCanhaoCamisolas from './assets/presentes/leves/gift_canhao_de_camisolas.webm';

import imgGiftCanhaoConfetes from './assets/presentes/miniaturas/gift_canhao_de_confetes.webp';
import vidGiftCanhaoConfetes from './assets/presentes/leves/gift_canhao_de_confetes.webm';

import imgGiftCapitao from './assets/presentes/miniaturas/gift_capitao.webp';
import vidGiftCapitao from './assets/presentes/leves/gift_capitao.webm';

import imgGiftCartaoAmarelo from './assets/presentes/miniaturas/gift_cartao_amarelo.webp';
import vidGiftCartaoAmarelo from './assets/presentes/leves/gift_cartao_amarelo.webm';

import imgGiftCartaoVermelho from './assets/presentes/miniaturas/gift_cartao_vermelho.webp';
import vidGiftCartaoVermelho from './assets/presentes/leves/gift_cartao_vermelho.webm';

import imgGiftChapeuGuardaRedes from './assets/presentes/miniaturas/gift_chapeu_de_guarda_redes.webp';
import vidGiftChapeuGuardaRedes from './assets/presentes/leves/gift_chapeu_de_guarda_redes.webm';

// Bloco Novos Presentes - Grupo 3 (Futebol)
import imgGiftChuteira from './assets/presentes/miniaturas/gift_chuteira.webp';
import vidGiftChuteira from './assets/presentes/leves/gift_chuteira.webm';

import imgGiftChuteirasChamas from './assets/presentes/miniaturas/gift_chuteiras_em_chamas.webp';
import vidGiftChuteirasChamas from './assets/presentes/leves/gift_chuteiras_em_chamas.webm';

import imgGiftCronometro from './assets/presentes/miniaturas/gift_cronometro.webp';
import vidGiftCronometro from './assets/presentes/leves/gift_cronometro.webm';

import imgGiftFiscalLinha from './assets/presentes/miniaturas/gift_fiscal_de_linha.webp';
import vidGiftFiscalLinha from './assets/presentes/leves/gift_fiscal_de_linha.webm';

import imgGiftFitasClaque from './assets/presentes/miniaturas/gift_fitas_da_claque.webp';
import vidGiftFitasClaque from './assets/presentes/leves/gift_fitas_da_claque.webm';

import imgGiftFumoClaque from './assets/presentes/miniaturas/gift_fumo_da_claque.webp';
import vidGiftFumoClaque from './assets/presentes/leves/gift_fumo_da_claque.webm';

import imgGiftGorroAdepto from './assets/presentes/miniaturas/gift_gorro_do_adepto.webp';
import vidGiftGorroAdepto from './assets/presentes/leves/gift_gorro_do_adepto.webm';

import imgGiftHallEntrada from './assets/presentes/miniaturas/gift_hall_de_entrada.webp';
import vidGiftHallEntrada from './assets/presentes/leves/gift_hall_de_entrada.webm';

import imgGiftHatTrick from './assets/presentes/miniaturas/gift_hat_trick.webp';
import vidGiftHatTrick from './assets/presentes/leves/gift_hat_trick.webm';

import imgGiftHolofotes from './assets/presentes/miniaturas/gift_holofotes.webp';
import vidGiftHolofotes from './assets/presentes/leves/gift_holofotes.webm';

// Bloco Novos Presentes - Grupo 4 (Futebol)
import imgGiftLuvaEspuma from './assets/presentes/miniaturas/gift_luva_de_espuma.webp';
import vidGiftLuvaEspuma from './assets/presentes/leves/gift_luva_de_espuma.webm';

import imgGiftLuvaPlatina from './assets/presentes/miniaturas/gift_luva_de_platina.webp';
import vidGiftLuvaPlatina from './assets/presentes/leves/gift_luva_de_platina.webm';

import imgGiftLuvasGuardaRedes from './assets/presentes/miniaturas/gift_luvas_de_guarda_redes.webp';
import vidGiftLuvasGuardaRedes from './assets/presentes/leves/gift_luvas_de_guarda_redes.webm';

import imgGiftMedalhaCampeao from './assets/presentes/miniaturas/gift_medalha_de_campeao.webp';
import vidGiftMedalhaCampeao from './assets/presentes/leves/gift_medalha_de_campeao.webm';

import imgGiftMedalhaViceCampeao from './assets/presentes/miniaturas/gift_medalha_de_vice_campeao.webp';
import vidGiftMedalhaViceCampeao from './assets/presentes/leves/gift_medalha_de_vice_campeao.webm';

import imgGiftMegafone from './assets/presentes/miniaturas/gift_megafone.webp';
import vidGiftMegafone from './assets/presentes/leves/gift_megafone.webm';

import imgGiftMeias from './assets/presentes/miniaturas/gift_meias.webp';
import vidGiftMeias from './assets/presentes/leves/gift_meias.webm';

import imgGiftMelhorTreinador from './assets/presentes/miniaturas/gift_melhor_treinador.webp';
import vidGiftMelhorTreinador from './assets/presentes/leves/gift_melhor_treinador.webm';

import imgGiftMoedaAoAr from './assets/presentes/miniaturas/gift_moeda_ao_ar.webp';
import vidGiftMoedaAoAr from './assets/presentes/leves/gift_moeda_ao_ar.webm';

import imgGiftPlacard from './assets/presentes/miniaturas/gift_placard.webp';
import vidGiftPlacard from './assets/presentes/leves/gift_placard.webm';

// Bloco Novos Presentes - Grupo 5 (Futebol - Final)
import imgGiftRelvado from './assets/presentes/miniaturas/gift_relvado.webp';
import vidGiftRelvado from './assets/presentes/leves/gift_relvado.webm';

import imgGiftSprayBarreira from './assets/presentes/miniaturas/gift_spray_de_barreira.webp';
import vidGiftSprayBarreira from './assets/presentes/leves/gift_spray_de_barreira.webm';

import imgGiftSubstituicao from './assets/presentes/miniaturas/gift_substituicao.webp';
import vidGiftSubstituicao from './assets/presentes/leves/gift_substituicao.webm';

import imgGiftTacaSuprema from './assets/presentes/miniaturas/gift_taca_suprema.webp';
import vidGiftTacaSuprema from './assets/presentes/leves/gift_taca_suprema.webm';

import imgGiftTamborClaque from './assets/presentes/miniaturas/gift_tambor_da_claque.webp';
import vidGiftTamborClaque from './assets/presentes/leves/gift_tambor_da_claque.webm';

import imgGiftTorresEstadio from './assets/presentes/miniaturas/gift_torres_do_estadio.webp';
import vidGiftTorresEstadio from './assets/presentes/leves/gift_torres_do_estadio.webm';

import imgGiftTrofeuCampeao from './assets/presentes/miniaturas/gift_trofeu_de_campeao.webp';
import vidGiftTrofeuCampeao from './assets/presentes/leves/gift_trofeu_de_campeao.webm';

import imgGiftTrofeuGuardaRedes from './assets/presentes/miniaturas/gift_trofeu_de_guarda_redes.webp';
import vidGiftTrofeuGuardaRedes from './assets/presentes/leves/gift_trofeu_de_guarda_redes.webm';

import imgGiftVitoria from './assets/presentes/miniaturas/gift_vitoria.webp';
import vidGiftVitoria from './assets/presentes/leves/gift_vitoria.webm';

import imgGiftVuvuzela from './assets/presentes/miniaturas/gift_vuvuzela.webp';
import vidGiftVuvuzela from './assets/presentes/leves/gift_vuvuzela.webm';

// 2. LISTA REAL
const PRESENTES_REAIS_LIVECAMPO = [
    // ==========================================
  // BLOCO 1: 150 MOEDAS
  // ==========================================
  { id: 1, nome: '90 Minutos', preco: 150, icone: imgGift90Minutos, video: vidGift90Minutos },
  { id: 2, nome: 'Anel de Campeão', preco: 150, icone: imgGiftAnelCampeao, video: vidGiftAnelCampeao },
  { id: 3, nome: 'Apito', preco: 150, icone: imgGiftApito, video: vidGiftApito },
  { id: 4, nome: 'Baliza', preco: 150, icone: imgGiftBaliza, video: vidGiftBaliza },
  { id: 5, nome: 'Bancada VIP', preco: 150, icone: imgGiftBancadaVip, video: vidGiftBancadaVip },

  // ==========================================
  // BLOCO 2: 300 MOEDAS
  // ==========================================
  { id: 6, nome: 'Banco de Suplentes', preco: 300, icone: imgGiftBancoSuplentes, video: vidGiftBancoSuplentes },
  { id: 7, nome: 'Bandeira da Claque', preco: 300, icone: imgGiftBandeiraClaque, video: vidGiftBandeiraClaque },
  { id: 8, nome: 'Bandeirola de Canto', preco: 300, icone: imgGiftBandeirolaCanto, video: vidGiftBandeirolaCanto },
  { id: 9, nome: 'Bola de Ouro', preco: 300, icone: imgGiftBolaOuro, video: vidGiftBolaOuro },
  { id: 10, nome: 'Bola em Chamas', preco: 300, icone: imgGiftBolaChamas, video: vidGiftBolaChamas },

    // ==========================================
  // BLOCO 3: 450 MOEDAS
  // ==========================================
  { id: 11, nome: 'Bota de Diamante', preco: 450, icone: imgGiftBotaDiamante, video: vidGiftBotaDiamante },
  { id: 12, nome: 'Brasão', preco: 450, icone: imgGiftBrasao, video: vidGiftBrasao },
  { id: 13, nome: 'Cachecol', preco: 450, icone: imgGiftCachecol, video: vidGiftCachecol },
  { id: 14, nome: 'Caneleiras', preco: 450, icone: imgGiftCaneleiras, video: vidGiftCaneleiras },
  { id: 15, nome: 'Canhão de Camisolas', preco: 450, icone: imgGiftCanhaoCamisolas, video: vidGiftCanhaoCamisolas },

  // ==========================================
  // BLOCO 4: 600 MOEDAS
  // ==========================================
  { id: 16, nome: 'Canhão de Confetes', preco: 600, icone: imgGiftCanhaoConfetes, video: vidGiftCanhaoConfetes },
  { id: 17, nome: 'Capitão', preco: 600, icone: imgGiftCapitao, video: vidGiftCapitao },
  { id: 18, nome: 'Cartão Amarelo', preco: 600, icone: imgGiftCartaoAmarelo, video: vidGiftCartaoAmarelo },
  { id: 19, nome: 'Cartão Vermelho', preco: 600, icone: imgGiftCartaoVermelho, video: vidGiftCartaoVermelho },
  { id: 20, nome: 'Chapéu de Guarda-Redes', preco: 600, icone: imgGiftChapeuGuardaRedes, video: vidGiftChapeuGuardaRedes },

    // ==========================================
  // BLOCO 5: 750 MOEDAS
  // ==========================================
  { id: 21, nome: 'Chuteira', preco: 750, icone: imgGiftChuteira, video: vidGiftChuteira },
  { id: 22, nome: 'Chuteiras em Chamas', preco: 750, icone: imgGiftChuteirasChamas, video: vidGiftChuteirasChamas },
  { id: 23, nome: 'Cronómetro', preco: 750, icone: imgGiftCronometro, video: vidGiftCronometro },
  { id: 24, nome: 'Fiscal de Linha', preco: 750, icone: imgGiftFiscalLinha, video: vidGiftFiscalLinha },
  { id: 25, nome: 'Fitas da Claque', preco: 750, icone: imgGiftFitasClaque, video: vidGiftFitasClaque },

  // ==========================================
  // BLOCO 6: 900 MOEDAS
  // ==========================================
  { id: 26, nome: 'Fumo da Claque', preco: 900, icone: imgGiftFumoClaque, video: vidGiftFumoClaque },
  { id: 27, nome: 'Gorro do Adepto', preco: 900, icone: imgGiftGorroAdepto, video: vidGiftGorroAdepto },
  { id: 28, nome: 'Hall de Entrada', preco: 900, icone: imgGiftHallEntrada, video: vidGiftHallEntrada },
  { id: 29, nome: 'Hat-Trick', preco: 900, icone: imgGiftHatTrick, video: vidGiftHatTrick },
  { id: 30, nome: 'Holofotes', preco: 900, icone: imgGiftHolofotes, video: vidGiftHolofotes },

    // ==========================================
  // BLOCO 7: 1050 MOEDAS
  // ==========================================
  { id: 31, nome: 'Luva de Espuma', preco: 1050, icone: imgGiftLuvaEspuma, video: vidGiftLuvaEspuma },
  { id: 32, nome: 'Luva de Platina', preco: 1050, icone: imgGiftLuvaPlatina, video: vidGiftLuvaPlatina },
  { id: 33, nome: 'Luvas de Guarda-Redes', preco: 1050, icone: imgGiftLuvasGuardaRedes, video: vidGiftLuvasGuardaRedes },
  { id: 34, nome: 'Medalha de Campeão', preco: 1050, icone: imgGiftMedalhaCampeao, video: vidGiftMedalhaCampeao },
  { id: 35, nome: 'Medalha de Vice-Campeão', preco: 1050, icone: imgGiftMedalhaViceCampeao, video: vidGiftMedalhaViceCampeao },

  // ==========================================
  // BLOCO 8: 1200 MOEDAS
  // ==========================================
  { id: 36, nome: 'Megafone', preco: 1200, icone: imgGiftMegafone, video: vidGiftMegafone },
  { id: 37, nome: 'Meias', preco: 1200, icone: imgGiftMeias, video: vidGiftMeias },
  { id: 38, nome: 'Melhor Treinador', preco: 1200, icone: imgGiftMelhorTreinador, video: vidGiftMelhorTreinador },
  { id: 39, nome: 'Moeda ao Ar', preco: 1200, icone: imgGiftMoedaAoAr, video: vidGiftMoedaAoAr },
  { id: 40, nome: 'Placard', preco: 1200, icone: imgGiftPlacard, video: vidGiftPlacard },

    // ==========================================
  // BLOCO 9: 1350 MOEDAS
  // ==========================================
  { id: 41, nome: 'Relvado', preco: 1350, icone: imgGiftRelvado, video: vidGiftRelvado },
  { id: 42, nome: 'Spray de Barreira', preco: 1350, icone: imgGiftSprayBarreira, video: vidGiftSprayBarreira },
  { id: 43, nome: 'Substituição', preco: 1350, icone: imgGiftSubstituicao, video: vidGiftSubstituicao },
  { id: 44, nome: 'Taça Suprema', preco: 1350, icone: imgGiftTacaSuprema, video: vidGiftTacaSuprema },
  { id: 45, nome: 'Tambor da Claque', preco: 1350, icone: imgGiftTamborClaque, video: vidGiftTamborClaque },

  // ==========================================
  // BLOCO 10: 1500 MOEDAS
  // ==========================================
  { id: 46, nome: 'Torres do Estádio', preco: 1500, icone: imgGiftTorresEstadio, video: vidGiftTorresEstadio },
  { id: 47, nome: 'Troféu de Campeão', preco: 1500, icone: imgGiftTrofeuCampeao, video: vidGiftTrofeuCampeao },
  { id: 48, nome: 'Troféu de Guarda-Redes', preco: 1500, icone: imgGiftTrofeuGuardaRedes, video: vidGiftTrofeuGuardaRedes },
  { id: 49, nome: 'Vitória', preco: 1500, icone: imgGiftVitoria, video: vidGiftVitoria },
  { id: 50, nome: 'Vuvuzela', preco: 1500, icone: imgGiftVuvuzela, video: vidGiftVuvuzela }
];

// =========================================================================
// 🎡 COMPONENTE 1: MOTOR DE MULTIPLICADORES LUCKYS (PROTECÇÃO BANCÁRIA)
// =========================================================================
const calcularResultadoLucky = (presenteLucky, fundoReservaDisponivel = 0) => {
  const precoItem = presenteLucky.preco || presenteLucky.custo || 0;
  const semente = Math.floor(Math.random() * 100000) + 1; // Base 100.000 para ler decimais finos
  let multiplicador = 0;

  // LÓGICA 1: CAÇA-JACKPOT 1000X (Estrela e Chuteira/Taça)
  if (presenteLucky.selo === 'jackpot_1000x') {
    // 0.096% de probabilidade de dar 1000X -> 96 sementes em 100.000
    if (semente <= 96) {
      multiplicador = 1000; // O JACKPOT SUPREMO!
    } else {
      multiplicador = 0; // 99.904% de probabilidade de PERDER TUDO
    }
  } 
  // LÓGICA 2: SELO DA CLAQUE / CAMISOLAS NORMAIS (Antigo Trevo calibrado)
  else {
    // Probabilidades Oficiais Ajustadas do Relatório Mestre
    if (semente <= 60890) {
      multiplicador = 0;   // Perder (0x) -> 60.89%
    } else if (semente <= 82890) {
      multiplicador = 1;   // Retorno (1x) -> 22.00%
    } else if (semente <= 94390) {
      multiplicador = 2;   // Dobro (2x) -> 11.50%
    } else if (semente <= 97390) {
      multiplicador = 5;   // 5x -> 3.00%
    } else if (semente <= 99390) {
      multiplicador = 10;  // 10x -> 2.00%
    } else if (semente <= 99890) {
      multiplicador = 20;  // 20x -> 0.50%
    } else if (semente <= 99990) {
      multiplicador = 50;  // 50x -> 0.10%
    } else {
      multiplicador = 100; // 100x -> 0.01%
    }
  }

  const custoPremioBolas = precoItem * multiplicador;

  // Proteção Bancária: Se o prémio ultrapassar o cofre disponível, força a devolução (1x) ou perda (0x)
  if (multiplicador > 1 && custoPremioBolas > fundoReservaDisponivel) {
    multiplicador = fundoReservaDisponivel >= precoItem ? 1 : 0;
  }

  return {
    multiplicador,
    premioFinalBolas: precoItem * multiplicador,
    ganhou: multiplicador > 0
  };
};

  function LiveCampo({ aoSair, idCanalLive: idCanalLiveProp, emLive, dadosUtilizador, setDadosUtilizador, setEcraAtivo, verPerfilNaLive }) {
    // Põe os vídeos dos presentes a descarregar já, para o primeiro presente não chegar atrasado.
    useAquecerPresentes(PRESENTES_REAIS_LIVECAMPO);
  // CONFIGURAÇÕES DE RECURSOS E CONTADORES DESPORTIVOS
  const [saldoBolas, setSaldoBolas] = useState(0);
  const [totalEspetadores, setTotalEspetadores] = useState(0);
  const [totalTapTaps, setTotalTapTaps] = useState(0);
  const [mostrarJanelaRanking, setMostrarJanelaRanking] = useState(false);
  const [usuarioSubiuScroll, setUsuarioSubiuScroll] = useState(false);
  const [micAtivo, setMicAtivo] = useState(true);
  // Sinaliza ao espetador que o navegador bloqueou o som e que precisa de tocar no ecrã.
  const [somBloqueado, setSomBloqueado] = useState(false);
  const [mostrarListaOnline, setMostrarListaOnline] = useState(false);
  const [listaUtilizadoresOnline, setListaUtilizadoresOnline] = useState([]);
  // Lista enriquecida com os dados REAIS do perfil (fotoUrl + nomeCompleto da coleção "utilizadores")
  const [espetadoresDetalhados, setEspetadoresDetalhados] = useState([]);
  const [meusSeguidos, setMeusSeguidos] = useState([]);

  // AVISO DIÁRIO DE NOVIDADES DO ESTÁDIO (uma vez por dia, hora local)
  const [mostrarAvisoEstadio, setMostrarAvisoEstadio] = useState(false);

      // =========================================================================
  // ⚡ LISTA DE LUCKYS OFICIAIS DO ESTÁDIO GAMEFUT LIVE (50 ITENS ATIVOS)
  // =========================================================================
  const LISTA_LUCKYS = [
    { id: 501, nome: 'Apito', preco: 1, icone: new URL('./assets/presentes/miniaturas/lucky_apito.webp', import.meta.url).href, tipo: 'lucky', selo: 'jackpot_1000x' },
    { id: 502, nome: 'Meias', preco: 2, icone: new URL('./assets/presentes/miniaturas/lucky_meias.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 503, nome: 'Caneleiras', preco: 5, icone: new URL('./assets/presentes/miniaturas/lucky_caneleiras.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 504, nome: 'Capitão', preco: 10, icone: new URL('./assets/presentes/miniaturas/lucky_capitao.webp', import.meta.url).href, tipo: 'lucky', selo: 'jackpot_1000x' },
    { id: 505, nome: 'Cronómetro', preco: 10, icone: new URL('./assets/presentes/miniaturas/lucky_cronometro.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 506, nome: '90 Minutos', preco: 12, icone: new URL('./assets/presentes/miniaturas/lucky_90_minutos.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 507, nome: 'Bota de Diamante', preco: 15, icone: new URL('./assets/presentes/miniaturas/lucky_bota_de_diamante.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 508, nome: 'Chapéu de Guarda-Redes', preco: 20, icone: new URL('./assets/presentes/miniaturas/lucky_chapeu_de_guarda_redes.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 509, nome: 'Luvas de Guarda-Redes', preco: 22, icone: new URL('./assets/presentes/miniaturas/lucky_luvas_de_guarda_redes.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 510, nome: 'Chuteira', preco: 25, icone: new URL('./assets/presentes/miniaturas/lucky_chuteira.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 511, nome: 'Cartão Amarelo', preco: 30, icone: new URL('./assets/presentes/miniaturas/lucky_cartao_amarelo.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 512, nome: 'Cartão Vermelho', preco: 35, icone: new URL('./assets/presentes/miniaturas/lucky_cartao_vermelho.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 513, nome: 'Spray de Barreira', preco: 40, icone: new URL('./assets/presentes/miniaturas/lucky_spray_de_barreira.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 514, nome: 'Bandeirola de Canto', preco: 50, icone: new URL('./assets/presentes/miniaturas/lucky_bandeirola_de_canto.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 515, nome: 'Fiscal de Linha', preco: 55, icone: new URL('./assets/presentes/miniaturas/lucky_fiscal_de_linha.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 516, nome: 'Baliza', preco: 60, icone: new URL('./assets/presentes/miniaturas/lucky_baliza.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 517, nome: 'Relvado', preco: 70, icone: new URL('./assets/presentes/miniaturas/lucky_relvado.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 518, nome: 'Banco de Suplentes', preco: 75, icone: new URL('./assets/presentes/miniaturas/lucky_banco_de_suplentes.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 519, nome: 'Substituição', preco: 80, icone: new URL('./assets/presentes/miniaturas/lucky_substituicao.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 520, nome: 'Hall de Entrada', preco: 90, icone: new URL('./assets/presentes/miniaturas/lucky_hall_de_entrada.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 521, nome: 'Bancada VIP', preco: 100, icone: new URL('./assets/presentes/miniaturas/lucky_bancada_vip.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 522, nome: 'Torres do Estádio', preco: 110, icone: new URL('./assets/presentes/miniaturas/lucky_torres_do_estadio.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 523, nome: 'Placard', preco: 120, icone: new URL('./assets/presentes/miniaturas/lucky_placard.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 524, nome: 'Holofotes', preco: 130, icone: new URL('./assets/presentes/miniaturas/lucky_holofotes.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 525, nome: 'Gorro de Adepto', preco: 140, icone: new URL('./assets/presentes/miniaturas/lucky_gorro_do_adepto.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 526, nome: 'Vuvuzela', preco: 150, icone: new URL('./assets/presentes/miniaturas/lucky_vuvuzela.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 527, nome: 'Moeda ao Ar', preco: 160, icone: new URL('./assets/presentes/miniaturas/lucky_moeda_ao_ar.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 528, nome: 'Luva de Espuma', preco: 170, icone: new URL('./assets/presentes/miniaturas/lucky_luva_de_espuma.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 529, nome: 'Cachecol', preco: 185, icone: new URL('./assets/presentes/miniaturas/lucky_cachecol.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 530, nome: 'Bandeira da Claque', preco: 200, icone: new URL('./assets/presentes/miniaturas/lucky_bandeira_da_claque.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 531, nome: 'Fitas da Claque', preco: 210, icone: new URL('./assets/presentes/miniaturas/lucky_fitas_da_claque.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 532, nome: 'Fumo da Claque', preco: 220, icone: new URL('./assets/presentes/miniaturas/lucky_fumo_da_claque.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 533, nome: 'Megafone', preco: 240, icone: new URL('./assets/presentes/miniaturas/lucky_megafone.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 534, nome: 'Canhão de Camisolas', preco: 260, icone: new URL('./assets/presentes/miniaturas/lucky_canhao_de_camisolas.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 535, nome: 'Canhão de Confetes', preco: 280, icone: new URL('./assets/presentes/miniaturas/lucky_canhao_de_confetes.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 536, nome: 'Tambor da Claque', preco: 300, icone: new URL('./assets/presentes/miniaturas/lucky_tambor_da_claque.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 537, nome: 'Chuteiras em Chamas', preco: 320, icone: new URL('./assets/presentes/miniaturas/lucky_chuteiras_em_chamas.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 538, nome: 'Bola em Chamas', preco: 350, icone: new URL('./assets/presentes/miniaturas/lucky_bola_em_chamas.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 539, nome: 'Hat-Trick', preco: 380, icone: new URL('./assets/presentes/miniaturas/lucky_hat_trick.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 540, nome: 'Medalha de Vice Campeão', preco: 400, icone: new URL('./assets/presentes/miniaturas/lucky_medalha_de_vice_campeao.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 541, nome: 'Medalha de Campeão', preco: 410, icone: new URL('./assets/presentes/miniaturas/lucky_medalha_de_campeao.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 542, nome: 'Melhor Treinador', preco: 420, icone: new URL('./assets/presentes/miniaturas/lucky_melhor_treinador.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 543, nome: 'Troféu de Campeão', preco: 430, icone: new URL('./assets/presentes/miniaturas/lucky_trofeu_de_campeao.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 544, nome: 'Troféu de Guarda-Redes', preco: 440, icone: new URL('./assets/presentes/miniaturas/lucky_trofeu_de_guarda_redes.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 545, nome: 'Luva de Platina', preco: 450, icone: new URL('./assets/presentes/miniaturas/lucky_luva_de_platina.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 546, nome: 'Brasão', preco: 460, icone: new URL('./assets/presentes/miniaturas/lucky_brasao.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 547, nome: 'Anel de Campeão', preco: 470, icone: new URL('./assets/presentes/miniaturas/lucky_anel_de_campeao.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 548, nome: 'Bola de Ouro', preco: 480, icone: new URL('./assets/presentes/miniaturas/lucky_bola_de_ouro.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 549, nome: 'Vitória', preco: 490, icone: new URL('./assets/presentes/miniaturas/lucky_vitoria.webp', import.meta.url).href, tipo: 'lucky' },
    { id: 550, nome: 'Taça Suprema', preco: 500, icone: new URL('./assets/presentes/miniaturas/lucky_taca_suprema.webp', import.meta.url).href, tipo: 'lucky' }
  ];

  // ⚡ GATILHOS EXCLUSIVOS PARA O MENU DE LUCKYS NAS LIVES A SOLO
  const [mostrarMenuLuckys, setMostrarMenuLuckys] = useState(false);
  const [mostrarMenuPresentesNormais, setMostrarMenuPresentesNormais] = useState(false);
  const [mostrarMenuStickers, setMostrarMenuStickers] = useState(false);
  const [tipoMenuAtivo, setTipoMenuAtivo] = useState(""); 
  const [utilizadorAlvoId, setUtilizadorAlvoId] = useState(null);
  const [quantidadeSelecionada, setQuantidadeSelecionada] = useState(1);
  const [ultimoLuckyEnviado, setUltimoLuckyEnviado] = useState(null);
  const [alvoUltimoLucky, setAlvoUltimoLucky] = useState(null);
  const [caixaForteBolas, setCaixaForteBolas] = useState(0); 
  const [avisoPresente, setAvisoPresente] = useState(null);
  const [animacoesAtivas, setAnimacoesAtivas] = useState([]);
  const [listaAvisosFeed, setListaAvisosFeed] = useState([]);
  const [comboPresenteAtivo, setComboPresenteAtivo] = useState(null);
  const [comboDestinatarioAtivo, setComboDestinatarioAtivo] = useState(null);
  const [contagemComboCliques, setContagemComboCliques] = useState(0);
  const [mostrarBolinhaRosa, setMostrarBolinhaRosa] = useState(false);
  const [presenteSelecionado, setPresenteSelecionado] = useState(null);
    const [mostrarSelecaoDestinatario, setMostrarSelecaoDestinatario] = useState(false);

    const [cromosDesbloqueadosIds, setCromosDesbloqueadosIds] = useState([]);

  useEffect(() => {
    // ALTERADO AQUI PARA A VARIÁVEL CORRETA DO TOPO DO COMPONENTE
    if (!idCanalLiveProp || !db) return;

    // Escuta em tempo real a caderneta_stickers do dono do canal (Mike)
    const userCadernetaRef = collection(db, "utilizadores", idCanalLiveProp, "caderneta_stickers");
    
    const unsubscribe = onSnapshot(userCadernetaRef, (snapshot) => {
      const desbloqueados = snapshot.docs.map(doc => String(doc.id));
      setCromosDesbloqueadosIds(desbloqueados);
    }, (error) => {
      console.error("Erro ao escutar caderneta na Live:", error);
    });

    return () => unsubscribe();
    // ATUALIZADO AQUI TAMBÉM NAS DEPENDÊNCIAS
  }, [idCanalLiveProp, db]);

  // Gestor do aviso em texto néon das Luckys
  useEffect(() => {
    if (!avisoPresente) return;
    const relogio = setTimeout(() => setAvisoPresente(null), 4000);
    return () => clearTimeout(relogio);
  }, [avisoPresente]);

  const [moedasClaqueSessao, setMoedasClaqueSessao] = useState(0);
  const [moedasAcumuladasLive, setMoedasAcumuladasLive] = useState(0);
  const [nomeLiderLive, setNomeLiderLive] = useState("Ninguém");

  // TRANCA DE SEGURANÇA CONTRA CHAMADAS DUPLAS DA AGORA

  // GUARDA A PISTA DE ÁUDIO LOCAL PARA O BOTÃO DE MICROFONE (mute/unmute fiável)
  const audioTrackRef = useRef(null);

  // CONTROLO ANTI-REPETIÇÃO DE PRESENTES: guarda o timestamp do último presente já
  // mostrado, para que outras alterações ao documento (ex.: Tap Tap) NÃO o repitam.
  const ultimoPresenteRef = useRef(null);
  const primeiraLeituraPresenteRef = useRef(true);

    // =========================================================================
  // 🎡 ANTENA EM TEMPO REAL: ESCUTADOR REATIVO DE LUCKYS E PRESENTES DA LIVE
  // =========================================================================
  const removerAnimacao = useCallback((chave) => {
    setAnimacoesAtivas((atuais) => atuais.filter((a) => a.chave !== chave));
  }, []);

    useEffect(() => {
    // 🟢 ALTERA ESTAS TRÊS LINHAS PARA USAR "idCanalEfetivo":
    if (!idCanalLiveProp) return;

    const animRef = collection(db, "lives_activas", idCanalLiveProp, "animacoes_presentes");
    const jaMostrados = new Set();
    const cronometrosDeCartao = new Set();

    const unsubAnim = onSnapshot(animRef, (snap) => {
      snap.docChanges().forEach((mudanca) => {
        if (mudanca.type !== "added") return;

        const idDoc = mudanca.doc.id;
        if (jaMostrados.has(idDoc)) return;
        jaMostrados.add(idDoc);

        const dados = mudanca.doc.data() || {};
        const carimboMs = dados.criadoEm?.toMillis?.() ?? null;
        if (carimboMs !== null && Date.now() - carimboMs > 90000) return;

        const media = dados.videoUrl || dados.iconeUrl || "";
        const ehLucky = !!dados.isLucky;

        // 1. Processamento de Animação WebM / MP4 no ecrã das Lives
        if (media && !ehLucky) {
          const ehVideo = /\.(mp4|webm|mov)(\?|#|\$)/i.test(media);
          const entrada = {
            chave: `${idDoc}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
            media,
            ehVideo,
            poster: dados.posterUrl || dados.iconeUrl || "",
          };
          setAnimacoesAtivas((atuais) => [...atuais, entrada].slice(-3));
        }

        // 2. Processamento do Cartão VIP de Alerta de Combos e Prêmios das Luckys
        const uidRemetente = dados.deUid || dados.uid || idDoc;
        const dadosCombo = {
          id: idDoc,
          uidRemetente,
          fotoRemetente: dados.deFoto || "",
          nomeRemetente: dados.deNome || "Craque",
          nomeDestinatario: dados.paraNome || "Streamer",
          presenteIcone: dados.posterUrl || dados.iconeUrl || media,
          presenteNome: dados.presenteNome,
          isLucky: ehLucky,
          multiplicadorGanho: Number(dados.multiplicador || 0),
          quantidadeCombo: Number(dados.quantidadeCombo || 1),
          totalGanhoBolas: Number(dados.totalGanhoBolas || 0)
        };
      
            // 🟢 ALERTA VIP MULTI-EMBALAGEM: Adiciona o prémio à lista global de Jackpots do topo
          if (ehLucky && Number(dados.multiplicador || 0) > 1) {
            const novoPremioVip = {
              id: idDoc,
              foto: dados.fotoRemetente || dados.deFoto || "/hero.png",
              nome: dados.nomeRemetente || dados.deNome || "Craque",
              multiplicador: Number(dados.multiplicador || 0)
            };

            // Se a lista global ainda não existir na memória do browser, cria-a vazia
            if (!window.listaJackpotsVip) window.listaJackpotsVip = [];
            
            // Adiciona o novo prémio no início e tranca o limite máximo em 3 para não tapar o ecrã
            window.listaJackpotsVip = [novoPremioVip, ...window.listaJackpotsVip.filter(j => j.id !== idDoc)].slice(0, 3);

            // Um temporizador limpa automaticamente este prémio específico da lista após 6 segundos
            setTimeout(() => {
              if (window.listaJackpotsVip) {
                window.listaJackpotsVip = window.listaJackpotsVip.filter(j => j.id !== idDoc);
                // Força uma pequena atualização visual neutra na live para o React atualizar o ecrã
                setAvisoPresente(prev => prev === " " ? "" : " ");
              }
            }, 3000);

            // Dispara o aviso néon para forçar o React a redesenhar a tela na hora
            setAvisoPresente(`🏆 JACKPOT: ${dados.nomeRemetente || "Um craque"} sacou ${dados.multiplicador}X! 🎉🔥`);
          }

        setListaAvisosFeed((prev) => [
          ...prev.filter((item) => item.uidRemetente !== uidRemetente),
          dadosCombo,
        ]);

        // Temporizador: Remove o cartão VIP do feed após 4 segundos
        const cronometro = setTimeout(() => {
          cronometrosDeCartao.delete(cronometro);
          setListaAvisosFeed((prev) => prev.filter((item) => item.id !== idDoc));
        }, 4000);
        cronometrosDeCartao.add(cronometro);

        // Áudio inteligente: Impede som sobreposto se for vídeo ou Lucky
        const ehVideoMP4 = /\.(mp4|webm|mov)(\?|#|\$)/i.test(String(dados?.videoUrl || ''));
        if (!ehLucky && !ehVideoMP4) {
          try {
            const somBomba = new Audio("/sounds/bomba-explosao.mp3");
            somBomba.volume = 1.0;
            somBomba.play().catch(() => {});
          } catch (errSom) {
            console.error("Erro ao tocar áudio da bomba na Live:", errSom);
          }
        }
      });
    }, (erro) => console.error("Escutador de presentes da live interrompido:", erro));

    return () => {
      unsubAnim();
      cronometrosDeCartao.forEach(clearTimeout);
      cronometrosDeCartao.clear();
    };
  }, [idCanalLiveProp]);

  // ESTADOS DO CHAT E TRANSMISSÃO (PRINTS 4 E 12)
  const [mensagensLive, setMensagensLive] = useState([]);
  const [textoMensagem, setTextoMensagem] = useState("");
  const [presenteAtivo, setPresenteAtivo] = useState(null);
  const [mostrarPresentes, setMostrarPresentes] = useState(false);
  const [mostrarCadernetaLive, setMostrarCadernetaLive] = useState(false);
  const [videoCromoAtivo, setVideoCromoAtivo] = useState(null);
  const [avisoCromo, setAvisoCromo] = useState(null);
  // FILA DE PRESENTES: um presente que chega enquanto outro ainda está a tocar
  // espera a sua vez, em vez de o cortar a meio (era o que acontecia: o segundo
  // presente apagava o primeiro no instante em que chegava). Até 5 à espera —
  // numa rajada de combos não vale a pena mostrar os 20 um a um.
  const presenteAtivoRef = useRef(null);
  const filaPresentesRef = useRef([]);
  const enfileirarPresente = useCallback((novo) => {
    if (presenteAtivoRef.current) {
      filaPresentesRef.current = [...filaPresentesRef.current, novo].slice(-5);
      return;
    }
    presenteAtivoRef.current = novo;
    setPresenteAtivo(novo);
  }, []);
  // Fecha o presente atual e puxa o seguinte da fila (ou limpa o ecrã).
  const terminarPresente = useCallback(() => {
    setVideoCromoAtivo(null);
    setAvisoCromo(null);
    const proximo = filaPresentesRef.current.shift() || null;
    presenteAtivoRef.current = proximo;
    setPresenteAtivo(proximo);
  }, []);
  // ⏱️ Sticker (sem vídeo): 2 s no ecrã e sai, puxando o seguinte da fila.
  useEffect(() => {
    if (!presenteAtivo || presenteAtivo.esVideo) return undefined;
    const relogio = setTimeout(terminarPresente, 2000);
    return () => clearTimeout(relogio);
  }, [presenteAtivo, terminarPresente]);
  const [cromosCadernetaLive, setCromosCadernetaLive] = useState([]);
  const [cromosDonoGanhosIds, setCromosDonoGanhosIds] = useState([]);
  const mensagensEndRef = useRef(null);
  const meuId = auth.currentUser?.uid;

  // CANAL EFETIVO DA LIVE (FONTE ÚNICA): o Feed passa 'liveId || uid', mas para alguns
  // espetadores esse prop chegava vazio quando o dadosUtilizador só tinha '.id'. Aí o
  // // letreiro do LÍDER e a barra de BOLAS ficavam presos (sensores faziam early-return),
  // enquanto o painel TOP — que já tinha este fallback — funcionava. Normalizamos aqui
  // uma vez para que TODOS os sensores leiam o mesmo canal correto.
  // Mudámos o nome de 'idCanalLive' para 'idCanalEfetivo' para não duplicar!
  const idCanalEfetivo = idCanalLiveProp || (emLive ? meuId : dadosUtilizador?.id || dadosUtilizador?.uid);

    // VARIÁVEIS DE CONTROLO PREMIUM PARA O MOTOR DA CLAQUE OFICIAL
  const [tapsClaqueAcumulados, setTapsClaqueAcumulados] = useState(0);
  const [euPertencoAClaque, setEuPertencoAClaque] = useState(false);
  const [metaClaqueAtingida, setMetaClaqueAtingida] = useState(false);
  const [membrosClaqueIds, setMembrosClaqueIds] = useState([]);
  const [mostrarConfettiClaque, setMostrarConfettiClaque] = useState(false);
  const confettiJaDisparadoRef = useRef(false);
  // GERA AS PEÇAS DO CONFETTI UMA ÚNICA VEZ (evita recalcular posições aleatórias a cada render)
  const pecasConfettiRef = useRef(
    Array.from({ length: 60 }, () => ({
      esquerda: Math.random() * 100,
      atraso: Math.random() * 1.5,
      duracao: 2.5 + Math.random() * 1.5,
      cor: ['#FFD700', '#00E5FF', '#39FF14', '#FF007F', '#FFFFFF'][Math.floor(Math.random() * 5)],
      tamanho: 6 + Math.random() * 8,
      rotacao: Math.random() * 360
    }))
  );

      // FUNCTION OFICIAL DE PARTILHA COM TORPEDO EM MASSA (BLOCO DO TOSHIBA)
  const partilharLiveReal = async () => {
    // 🟢 MUDADO PARA idCanalEfetivo AQUI:
    const linkOficial = `${window.location.origin}/?app&live=${idCanalEfetivo || 'arena'}`;
    
    if (navigator.share) {
      navigator.share({
        title: 'Game Fut Live ⚽🔥',
        text: 'Entra agora no estádio! Estou em direto ao vivo!',
        url: linkOficial
      }).catch((err) => console.log("Partilha cancelada:", err));
    } else {
      navigator.clipboard.writeText(linkOficial);
      alert("Link do estádio copiado para a área de transferência! 🔗⚽");
    }

    try {
      const { collection: fColl, addDoc: fAdd, serverTimestamp: fTime } = await import('firebase/firestore');
      await fAdd(fColl(db, "notificacoes"), {
        tipo: "LIVE_START",
        titulo: "ESTÁDIO EM FOGO! ⚽🔥",
        mensagem: "O craque abriu uma transmissão! Clica para entrar nas bancadas!",
        // 🟢 MUDADO PARA idCanalEfetivo AQUI TAMBÉM:
        canalId: idCanalEfetivo || "",
        criadoEm: fTime()
      });
    } catch (firebaseErr) {
      console.error("Erro ao enviar torpedo de notificação:", firebaseErr);
    }
  };

    // 🟢 SENSOR REATIVO DA CADERNETA: Lê os cromos adquiridos do streamer em tempo real na live
  useEffect(() => {
    const canalId = idCanalEfetivo || (emLive ? meuId : null);
    if (!canalId || !db) return;

    // 1. Carrega a lista base dos 50 cromos vazios da tua configuração
    const listaBase = typeof obterListaCompleta50Cromos === 'function' ? obterListaCompleta50Cromos() : [];

    // 2. Liga a escuta em tempo real usando as funções nativas já existentes no topo do teu ficheiro
    const cadernetaRef = collection(db, "utilizadores", canalId, "caderneta_stickers");
    
    const unsubscribe = onSnapshot(cadernetaRef, (snapshot) => {
      // Cria um array com os IDs dos cromos que o streamer já tem (ex: ["1", "2"])
      const idsAdquiridos = snapshot.docs.map(doc => String(doc.id));
      
      // Atualiza os cromos marcando como 'adquirido: true' se o número do cromo estiver no Firebase
      const listaAtualizada = listaBase.map(cromo => ({
        ...cromo,
        adquirido: idsAdquiridos.includes(String(cromo.cromoNumero))
      }));

      setCromosCadernetaLive(listaAtualizada);
    }, (err) => console.error("Erro ao escutar caderneta na live:", err));

    return () => unsubscribe();
  }, [idCanalEfetivo, emLive, meuId]);

        // ESCUTADOR REATIVO DE CROMOS DO TREVO COM SOM DE BOMBA PREMIUM (CÓPIADO DA SALA)
  useEffect(() => {
    const canalId = idCanalEfetivo || (emLive ? meuId : null);
    if (!canalId || !db) return;

    const liveAnimRef = collection(db, "utilizadores", canalId, "animacoes_caderneta");
    let timeoutCromo = null;
    let primeiraCargaCromos = true;

    const unsubscribe = onSnapshot(liveAnimRef, (snapshot) => {
      if (primeiraCargaCromos) {
        primeiraCargaCromos = false;
        return;
      }

      snapshot.docChanges().forEach((change) => {
        if (change.type !== "added") return;

        const dados = change.doc.data();
        if (!dados) return;

        // Captura o link em qualquer uma das propriedades gravadas pelo teu botão do trevo
        const linkDoSticker = dados.iconeUrl || dados.videoUrl || dados.icone || dados.presenteAnimacao || "";
        if (!linkDoSticker) return;

        const nomeDoador = dados.deNome || "Um craque";
        const nomePresente = String(dados.presenteNome || "CROMO").toUpperCase();

        // 🟢 IGUAL ÀS SALAS: Dispara diretamente os estados sem passar pelo preCarregador!
        setVideoCromoAtivo(linkDoSticker);
        setAvisoCromo(`${nomeDoador} DOOU O ${nomePresente}! 🏟️🏆`);

        // Toca o som da bomba premium na hora
        try {
          const somBomba = new Audio("/sounds/bomba-explosao.mp3");
          somBomba.volume = 1.0;
          somBomba.play().catch(err => console.log("Permissão de áudio pendente:", err));
        } catch (errSom) { 
          console.error("Erro ao tocar áudio da bomba:", errSom); 
        }

        // Limpador automático de 4 segundos
        if (timeoutCromo) clearTimeout(timeoutCromo);
        timeoutCromo = setTimeout(() => {
          setVideoCromoAtivo(null);
          setAvisoCromo(null);
          timeoutCromo = null;
        }, 4000);
      });
    });

    return () => {
      if (timeoutCromo) clearTimeout(timeoutCromo);
      unsubscribe();
    };
  }, [idCanalEfetivo, db, emLive, meuId]);

    // SENSOR REATIVO DE ADESÃO VITALÍCIA E ESCUTA DE TAPS DA CLAQUE EM TEMPO REAL
useEffect(() => {
  if (!idCanalEfetivo || !db || !auth?.currentUser?.uid) {
    return;
  }

  const meuUidAtual = auth.currentUser.uid;

  // 1. VERIFICAÇÃO VITALÍCIA
  const verificarClaque = async () => {
    try {
      const docClaqueRef = doc(
        db,
        "utilizadores",
          idCanalEfetivo,
        "claque_membros",
        meuUidAtual
      );

      const snapMembro = await getDoc(docClaqueRef);

      if (snapMembro.exists() && snapMembro.data()?.ativo === true) {
        setEuPertencoAClaque(true);
      } else {
        setEuPertencoAClaque(false);
      }
    } catch (erro) {
      console.error(
        "Erro ao verificar claque vitalícia:",
        erro
      );
    }
  };

  verificarClaque();

  // 2. ESCUTA EM TEMPO REAL
  const liveDocRef = doc(db, "lives_activas", idCanalEfetivo);

  const unsubscribeClaque = onSnapshot(
    liveDocRef,
    (snapLive) => {
      if (!snapLive.exists()) return;

      const dadosLive = snapLive.data();
      const tapsAtuais = Number(dadosLive?.tapsClaque || 0);

      setTapsClaqueAcumulados(tapsAtuais);
      setMetaClaqueAtingida(tapsAtuais >= 5000);
    },
    (erro) => {
      console.error(
        "Erro no onSnapshot da claque:",
        erro
      );
    }
  );

  return () => {
    unsubscribeClaque();
  };
}, [idCanalEfetivo, db]);

  // ESCUTA EM TEMPO REAL OS MEMBROS VITALÍCIOS DA CLAQUE (PARA O BRILHO DOURADO NO CHAT)
  useEffect(() => {
    if (!idCanalEfetivo || !db) return;
    const membrosRef = collection(db, "utilizadores", idCanalEfetivo, "claque_membros")
    const unsubscribeMembros = onSnapshot(membrosRef, (snapshot) => {
      const idsAtivos = snapshot.docs
        .filter((d) => d.data()?.ativo === true)
        .map((d) => d.id);
      setMembrosClaqueIds(idsAtivos);
    });
    return () => unsubscribeMembros();
  }, [idCanalEfetivo, db]);

  // DISPARA A CHUVA DE CONFETTI NO EXATO MOMENTO EM QUE A CLAQUE ATINGE 5000 TAPS
  useEffect(() => {
    if (metaClaqueAtingida && !confettiJaDisparadoRef.current) {
      confettiJaDisparadoRef.current = true;
      setMostrarConfettiClaque(true);
      setTimeout(() => setMostrarConfettiClaque(false), 5000);
    }
    if (!metaClaqueAtingida) {
      confettiJaDisparadoRef.current = false;
    }
  }, [metaClaqueAtingida]);

    // Escuta em tempo real os cromos que o Streamer já tem desbloqueados
  useEffect(() => {
    if (!idCanalEfetivo || !db) return;
    
    // Usa a coleção direta ligada ao ID do canal aberto
    const streamerCadernetaRef = collection(db, "utilizadores", idCanalEfetivo, "caderneta")
    
    const unsubscribe = onSnapshot(streamerCadernetaRef, (snapshot) => {
      setCromosDonoGanhosIds(snapshot.docs.map(doc => Number(doc.id)));
    });
    
    return () => unsubscribe();
  }, [idCanalEfetivo, db]);

  useEffect(() => {
    if (!meuId) return;
    const userRef = doc(db, "utilizadores", meuId);
    const unsubSaldo = onSnapshot(userRef, (docSnap) => {
      if (docSnap.exists()) {
        const dados = docSnap.data();
        setSaldoBolas(dados?.saldoBolas || 0);
      }
    });
    return () => unsubSaldo();
  }, [meuId]);

    // SENSOR DE QUEM EU SIGO: alimenta o botão +SEGUIR com os dados do espetador atual
  useEffect(() => {
    const meuUidAtual = auth.currentUser?.uid;
    if (!meuUidAtual || !db) return;

    const followingRef = collection(db, "utilizadores", meuUidAtual, "seguindo");
    
    const unsubSeguidos = onSnapshot(followingRef, (snap) => {
      const IDsEncontrados = snap.docs.map((d) => d.id);
      setMeusSeguidos(IDsEncontrados);
    });

    return () => unsubSeguidos();
  }, [auth.currentUser?.uid]);

    // SENSOR DO CHAT PÚBLICO EM TEMPO REAL COM SCROLL AUTOMÁTICO (PRINT 12 DO TOSHIBA)
    useEffect(() => {
    if (!idCanalEfetivo) return;

    const chatRef = collection(db, "lives_activas", idCanalEfetivo, "chat");
    const qChat = query(chatRef, orderBy("criadoEm", "asc"));

    const unsubscribeChat = onSnapshot(qChat, (snapshot) => {
      const listaMensagens = [];
      snapshot.forEach((doc) => {
        listaMensagens.push({ id: doc.id, ...doc.data() });
      });
      setMensagensLive(listaMensagens);

      // SCROLL AUTOMÁTICO ESTILO TIKTOK: EMPURRA AS MENSAGENS NOVAS DO FUNDO PARA CIMA
      setTimeout(() => {
        if (mensagensEndRef.current) {
          mensagensEndRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
      }, 100);
    });

    return () => unsubscribeChat();
  }, [idCanalEfetivo]);

      // SENSOR REAI DO 1º LUGAR DO RANKING (LETREIRO DOURADO FIEL)
  useEffect(() => {
    // Resolve o canal igual ao painel TOP: o Dono (emLive) transmite no seu próprio
    // uid, logo 'idCanalLive' vem vazio para ele. Sem este fallback o letreiro ficava
    // preso em "Ninguém" mesmo havendo líder real no ranking.
    const canalId = idCanalEfetivo || (emLive ? meuId : null);
    if (!canalId) return;

    const rankingRef = collection(db, "lives_activas", canalId, "ranking");
    const qRanking = query(rankingRef, orderBy("totalGasto", "desc"), limit(1));

              const unsubscribeLider = onSnapshot(qRanking, async (snapshot) => {
      try {
        // Coleção inteira vazia => único caso em que o letreiro mostra "Ninguém".
        if (snapshot.empty || !snapshot.docs[0]) {
          setNomeLiderLive("Ninguém");
          return;
        }

        const docLider = snapshot.docs[0];
        const dadosLider = docLider.data();
        // Nome REAL do líder vindo do PERFIL (igual ao painel TOP). O doc do ranking
        // pode não ter 'nomeCompleto' gravado (dados antigos) — e era isso que prendia
        // o letreiro em "Ninguém" enquanto o painel mostrava o nome certo. Fallback
        // para os campos do ranking se o perfil falhar.
        let nomeLider = dadosLider?.nomeCompleto || dadosLider?.nome;
        try {
          const perfilSnap = await getDoc(doc(db, "utilizadores", docLider.id));
          if (perfilSnap.exists()) {
            const perfil = perfilSnap.data();
            nomeLider = perfil.nomeCompleto || perfil.nome || nomeLider;
          }
        } catch (errPerfil) {
          console.error("Erro ao carregar perfil do líder:", errPerfil);
        }
        if (nomeLider) {
          setNomeLiderLive(nomeLider);
        }
      } catch (err) {
        console.error("Erro ao ler o líder do topo:", err);
      }
    });

    return () => unsubscribeLider();
  }, [idCanalEfetivo, emLive, meuId]);

    // REGISTA COMO ESPETADOR E CONTA PESSOAS NO ESTÁDIO (BLOCO 4 DO TOSHIBA)
  useEffect(() => {
    if (!idCanalEfetivo || !meuId) return;

    let unsubEspetadores;

    const iniciarSensorEspetadores = async () => {
      const { doc, setDoc, serverTimestamp, collection, onSnapshot } = await import('firebase/firestore');

      // 1. Regista o adepto como espectador ativo (o Dono da live não conta como espetador)
              if (!emLive) {
          await setDoc(doc(db, "lives_activas", idCanalLiveProp, "assistindo", meuId), {
            userId: meuId,
            userName: auth.currentUser?.displayName || "Craque",
            fotoUrl: auth.currentUser?.photoURL || "",
            entrouEm: new Date()
          }).catch(e => console.error("Erro ao registar espetador:", e));
        }

      // 2. Escuta em tempo real o total de pessoas dentro do estádio
      // (o Dono TAMBÉM precisa desta escuta, senão o olhinho dele fica sempre a 0)
              const qAssistindo = collection(db, "lives_activas", idCanalLiveProp, "assistindo");
            unsubEspetadores = onSnapshot(qAssistindo, (snap) => {
        setTotalEspetadores(snap.size);

        // CARREGA OS DADOS REAIS DAS BANCADAS
        const usuarios = [];
        snap.forEach(d => usuarios.push({ id: d.id, ...d.data() }));
        setListaUtilizadoresOnline(usuarios);
      });
    };

    iniciarSensorEspetadores();

    return () => {
      if (unsubEspetadores) unsubEspetadores();
      // Apaga o registo do espetador ao sair, para o olhinho descer em tempo real
      if (!emLive) {
        import('firebase/firestore').then(({ doc: fDoc, deleteDoc: fDeleteDoc }) => {
          fDeleteDoc(fDoc(db, "lives_activas", idCanalEfetivo, "assistindo", meuId)).catch(() => {});
        });
      }
    };
  }, [idCanalEfetivo, meuId, emLive]);

    // SENSOR DE BANIDOS E TAP-TAPS (BLOCO 5 DO TOSHIBA)
  useEffect(() => {
    if (!idCanalEfetivo || !meuId) return;

    let unsubBanidoLive;
    let unsubTaps;

    const iniciarSensoresSegurancaYInteracao = async () => {
      const { doc, onSnapshot } = await import('firebase/firestore');

      // 1. SENSOR DE SEGURANÇA MÁXIMA: Expulsão se fores banido
      unsubBanidoLive = onSnapshot(doc(db, "lives_activas", idCanalEfetivo, "banidos", meuId), (banSnap) => {
        if (banSnap.exists()) {
          setEcraAtivo('feed');
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      });

      // 2. ESCUTA EM TEMPO REAL O TOTAL DE CLIQUES, MOEDAS E INTERAÇÕES DA LIVE
        unsubTaps = onSnapshot(doc(db, "lives_activas", idCanalEfetivo), (docSnap) => {
          if (docSnap.exists()) {
            const dadosServidor = docSnap.data();
            setTotalTapTaps(dadosServidor.totalTapTaps || 0);
            
            // Sincronizar a tua caixa de texto de moedas com o servidor em tempo real
            setMoedasAcumuladasLive(dadosServidor.totalMoedasLive || 0);
                      // 🚨 ALINHAMENTO SAGRADO: Lê o cofre em tempo real para o motor das Luckys nunca ficar cego!
          setCaixaForteBolas(dadosServidor.fundoReservaLuckys || 0);
            
            // NOTA: 'nomeLiderLive' NÃO é lido aqui de propósito. O líder do topo é
            // a fonte única do listener dedicado ao ranking (orderBy totalGasto desc, limit 1).
          }
        });
    };

    iniciarSensoresSegurancaYInteracao();

    return () => {
      if (unsubBanidoLive) unsubBanidoLive();
      if (unsubTaps) unsubTaps();
    };
  }, [idCanalEfetivo, meuId, setEcraAtivo]);

   // FUNÇÃO AUXILIAR PARA ENVIAR MENSAGEM MANUALMENTE NO CHAT
  const enviarMensagemChat = async (e) => {
    if (e) e.preventDefault();
    if (!textoMensagem.trim() || !idCanalEfetivo) return;

    try {
      const chatRef = collection(db, "lives_activas", idCanalEfetivo, "chat");
      
      // Ajustado de forma definitiva para ler do teu objeto de produção: userDados
      const fotoReal = auth.currentUser?.photoURL || userDados?.fotoUrl || userDados?.fotoPerfil || '/hero.png';

      await addDoc(chatRef, {
        texto: textoMensagem,
        tipo: "texto",
        uid: meuId,
        nome: auth.currentUser?.displayName || userDados?.nomeCompleto || "Adepto",
        foto: fotoReal,
        criadoEm: serverTimestamp(),
        
        // Agora sim bate 100% certo com as tuas variáveis reais da base de dados!
        nivelAdepto: calcularNivel(userDados?.xpAdepto || 0),
        nivelJogador: calcularNivel(userDados?.xpJogador || 0)
      });
      
      setTextoMensagem("");
    } catch (errMsg) {
      console.error("Erro ao enviar mensagem:", errMsg);
    }
  };

  // ENRIQUECEDOR DA LISTA DE BANCADAS: quando o olhinho 👁️ abre a lista, vai buscar
  // os dados REAIS de cada espetador à coleção "utilizadores" (fotoUrl + nomeCompleto),
  // em vez de mostrar o que ficou guardado na subcoleção "assistindo".
  useEffect(() => {
    if (!mostrarListaOnline) return;
    let ativo = true;

    const carregarPerfisReais = async () => {
      const { doc: fDoc, getDoc: fGetDoc } = await import('firebase/firestore');
      const detalhes = await Promise.all(
        listaUtilizadoresOnline.map(async (esp) => {
          const idEsp = esp.userId || esp.id;
          try {
            const snap = await fGetDoc(fDoc(db, "utilizadores", idEsp));
            const perfil = snap.exists() ? snap.data() : {};
            return {
              userId: idEsp,
              nome: perfil.nomeCompleto || esp.userName || "Craque",
              foto: perfil.fotoUrl || perfil.fotoPerfil || perfil.photoURL || esp.fotoUrl || '/hero.png'
            };
          } catch (erroPerfil) {
            console.error("Erro ao carregar perfil do espetador:", erroPerfil);
            return { userId: idEsp, nome: esp.userName || "Craque", foto: esp.fotoUrl || '/hero.png' };
          }
        })
      );
      if (ativo) setEspetadoresDetalhados(detalhes);
    };

    carregarPerfisReais();
    return () => { ativo = false; };
  }, [mostrarListaOnline, listaUtilizadoresOnline]);

  // ABRE O PERFIL DE UM ESPETADOR SEM PERDER A LIGAÇÃO DA LIVE.
  // Em vez de trocar de ecrã (o que desmontava a LiveCampo e cortava o Agora),
  // sobrepõe o perfil POR CIMA da live, com um botão "Voltar à Live".
  const abrirPerfilEspetador = async (userId) => {
    if (!userId) return;
    try {
      const { doc: fDoc, getDoc: fGetDoc } = await import('firebase/firestore');
      const snap = await fGetDoc(fDoc(db, "utilizadores", userId));
      const userData = { uid: userId, ...(snap.exists() ? snap.data() : {}) };
      setMostrarListaOnline(false);
      if (typeof verPerfilNaLive === 'function') {
        // Mantém a LiveCampo montada (ligação Agora intacta) e mostra o perfil por cima
        verPerfilNaLive(userData);
      } else {
        // Reserva: navegação antiga (caso o pai não tenha passado o overlay)
        setDadosUtilizador(userData);
        setEcraAtivo('perfil');
      }
    } catch (errPerfil) {
      console.error("Erro ao abrir perfil do espetador:", errPerfil);
    }
  };

  // ENCERRAMENTO OFICIAL DA LIVE (SÓ O DONO):
  // 1) Encontra o 1º lugar do ranking e envia-lhe a notificação de 5% de Cashback
  //    (com o nome do Anfitrião e prazo estrito de 7 dias em "expiraEm").
  // 2) Limpa as subcoleções "chat" e "ranking" desta live para que a próxima comece a ZERO.
  // 3) Marca a live como encerrada e sai.
  const encerrarLiveComCashback = async () => {
    if (auth.currentUser?.uid !== idCanalEfetivo) { aoSair(); return; }

    try {
      const {
        collection: fColl, query: fQuery, orderBy: fOrderBy, limit: fLimit,
        getDocs: fGetDocs, addDoc: fAddDoc, doc: fDoc, updateDoc: fUpdateDoc,
        writeBatch: fWriteBatch, serverTimestamp: fTimestamp, Timestamp: fTs
      } = await import('firebase/firestore');

      // 1. DESCOBRE O MAIOR PRESENTEADOR (1º LUGAR) ANTES DE LIMPAR O RANKING
      const qTopo = fQuery(
        fColl(db, "lives_activas", idCanalEfetivo, "ranking"),
        fOrderBy("totalGasto", "desc"),
        fLimit(1)
      );
      const topoSnap = await fGetDocs(qTopo);

      if (!topoSnap.empty) {
        const vencedorDoc = topoSnap.docs[0];
        const vencedorUid = vencedorDoc.id;
        const totalGasto = vencedorDoc.data().totalGasto || 0;
        const valorPremio = Math.floor(totalGasto * 0.05); // 5% de Cashback

        // Só premeia se houver gasto real e se o vencedor não for o próprio Anfitrião
        if (valorPremio > 0 && vencedorUid !== auth.currentUser?.uid) {
          const nomeAnfitriao = auth.currentUser?.displayName || dadosUtilizador?.donoNome || "o Anfitrião";
          // PRAZO ESTRITO DE 7 DIAS
          const expiraEm = fTs.fromMillis(Date.now() + 7 * 24 * 60 * 60 * 1000);

          await fAddDoc(fColl(db, "utilizadores", vencedorUid, "notificacoes"), {
            remetenteId: idCanalEfetivo,
            remetenteNome: nomeAnfitriao,
            tipo: "recompensa_ranking_live",
            dados: {
              valorPremio,
              textoCustom: `Ganhaste 5% de Cashback da live de ${nomeAnfitriao}! 🏆💰`,
              liveId: idCanalEfetivo,
              expiraEm
            },
            expiraEm,
            lida: "false",
            timestamp: fTimestamp()
          });
        }
      }

      // 2. LIMPA O CHAT E O RANKING (PRESENTES) DESTA LIVE → A PRÓXIMA COMEÇA A ZERO
      for (const subcolecao of ["chat", "ranking"]) {
        const docsSnap = await fGetDocs(fColl(db, "lives_activas", idCanalEfetivo, subcolecao));
        // O Firestore limita cada batch a 500 operações — partimos em lotes seguros.
        let lote = fWriteBatch(db);
        let contador = 0;
        for (const d of docsSnap.docs) {
          lote.delete(d.ref);
          contador++;
          if (contador === 450) {
            await lote.commit();
            lote = fWriteBatch(db);
            contador = 0;
          }
        }
        if (contador > 0) await lote.commit();
      }

      // 3. MARCA A LIVE COMO ENCERRADA (faz sumir da TV e expulsa os espetadores)
      await fUpdateDoc(fDoc(db, "lives_activas", idCanalEfetivo), { status: "encerrada" });
    } catch (eEncerrar) {
      console.error("Erro ao encerrar a live com cashback:", eEncerrar);
    }

    aoSair();
  };

    // MOTOR DA CÂMARA AGORARTC E EXPULSÃO AUTOMÁTICA (PRINTS 3, 4 E 13 DO TOSHIBA)
  const [streamLocal, setStreamLocal] = useState(null);
  const [utilizadoresRemotos, setUtilizadoresRemotos] = useState([]);
  // SESSÃO AGORA partilhada (ver agoraSession.js). Substitui o antigo
  // window.agoraClientLive, que era global e nunca era destruído.
  const ligacao = useSessaoAgora('LiveCampo');

  useEffect(() => {
    if (!idCanalEfetivo) return;

        // 1. PROTOCOLO DE SINALIZAÇÃO E EXPULSÃO SE A LIVE FECHAR (PRINT 13)
    const liveDocRef = doc(db, "lives_activas", idCanalEfetivo);
    const unsubscribeLive = onSnapshot(liveDocRef, async (snap) => {
      if (!snap.exists() || snap.data()?.status === "encerrada") {
        // O Dono encerra pela mão dele (botão ENCERRAR) — este sensor só expulsa os espetadores
        if (auth.currentUser?.uid === idCanalEfetivo) return;

        console.log("Live encerrada pelo anfitrião. A desligar antenas...");

        // Fecha a sessão por completo: pistas, handlers e canal.
        await ligacao.terminar();

        alert("Esta transmissão foi encerrada! 🏟️");
        aoSair(); // Chuta o utilizador de volta à TV
      } else {
        // LÊ O SENSOR DE PRESENTES NA TELA (PRINT 13)
        const data = snap.data();
        // Timestamp do último presente. Só reproduzimos quando ELE muda — assim o
        // Tap Tap (que escreve totalTapTaps no mesmo documento) não dispara presentes.
        const tsPresente = data?.ultimoPresenteEm?.toMillis ? data.ultimoPresenteEm.toMillis() : null;

    if (primeiraLeituraPresenteRef.current) {
          // Primeira leitura ao entrar na live: regista o estado atual sem reproduzir
          // (evita repetir um presente antigo que já estava no documento).
          primeiraLeituraPresenteRef.current = false;
          ultimoPresenteRef.current = tsPresente;
        } else if (data?.presenteAnimacao && tsPresente && tsPresente !== ultimoPresenteRef.current) {
          ultimoPresenteRef.current = tsPresente;
          
          // Antes só contava .mp4 — os 50 presentes .webm eram tratados como
          // sticker e fechados à força ao fim de 2 segundos, a meio do vídeo.
          const esVideo = /\.(mp4|webm|mov)(\?|#|$)/i.test(String(data?.presenteAnimacao || ''));

          enfileirarPresente({
            url: data?.presenteAnimacao,
            // Dois anéis seguidos têm o mesmo url: sem esta chave o segundo
            // não recomeçava o vídeo.
            chave: tsPresente,
            esVideo,
            texto: emLive 
              ? "Recebeste um presente premium de " + (data?.presenteRemetenteNome || data?.presenteTexto || "um craque") + "!"
              : (data?.presenteRemetenteUid === auth.currentUser?.uid 
                  ? "Enviaste um presente premium!" 
                  : (data?.presenteRemetenteNome || "Alguém") + " enviou um presente premium!")
          });
          // (O relógio de 2 s dos stickers vive num efeito próprio, mais abaixo:
          //  só começa a contar quando o sticker entra mesmo no ecrã.)
        }
      }
    });

    // Este onSnapshot também é registado na sessão: se o teardown correr
    // primeiro (saída a meio de uma entrada), fica igualmente desligado.
    ligacao.registarListener(unsubscribeLive);

    return () => unsubscribeLive();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idCanalEfetivo, emLive]);

  // 2. LIGAÇÃO DE VÍDEO/ÁUDIO DA LIVE.
  // O anfitrião entra como "host" e publica; quem assiste entra como
  // "audience" e só subscreve. `ligacao.tentativa` está nas dependências para
  // o botão TENTAR DE NOVO voltar a correr isto.
  useEffect(() => {
    if (!idCanalEfetivo) return;

    const souODono = auth.currentUser?.uid === idCanalEfetivo;

    const entrarNaLive = async () => {
      // Token real da Cloud Function; sem ele entra em modo App ID.
      let tokenLive = null;
      try {
        const { httpsCallable } = await import('firebase/functions');
        const { functions: fbFunctions } = await import('./firebase');
        const gerarToken = httpsCallable(fbFunctions, 'gerarTokenAgora');
        const resToken = await gerarToken({ idBatalha: idCanalEfetivo });
        tokenLive = resToken?.data?.token || null;
      } catch (eToken) {
        console.log("Token Agora indisponível, a entrar em modo App ID:", eToken?.message);
      }

      // POLÍTICA DE AUTOPLAY: se o navegador bloquear o som (o espetador ainda
      // não tocou no ecrã), mostramos o aviso e retomamos ao primeiro toque.
      AgoraRTC.onAutoplayFailed = () => {
        setSomBloqueado(true);
        const retomarAudio = () => {
          ligacao.sessao.cliente?.remoteUsers.forEach((u) => {
            try { u.audioTrack?.play(); } catch (ePlay) { console.log(ePlay); }
          });
          setSomBloqueado(false);
          document.removeEventListener('click', retomarAudio);
          document.removeEventListener('touchstart', retomarAudio);
        };
        document.addEventListener('click', retomarAudio);
        document.addEventListener('touchstart', retomarAudio);
      };

      const resultado = await ligacao.entrar({
        appId: AGORA_APP_ID,
        canal: idCanalEfetivo,
        token: tokenLive,
        uid: null,
        modo: 'live',
        papel: souODono ? 'host' : 'audience',
        publicar: souODono,
        opcoesAudio: { AEC: true, ANS: true, AGC: true },
        opcoesVideo: { facingMode: 'user' },
        // O vídeo local não vai por id: a <div> usa um ref callback, por isso
        // guardamos a pista no estado e é o React que a manda tocar.
        contentorLocal: null,
        aoPublicarRemoto: (utilizador, tipoMedia) => {
          if (tipoMedia === "video") {
            setUtilizadoresRemotos((prev) => [...prev.filter(u => u.uid !== utilizador.uid), utilizador]);
          }
          if (tipoMedia === "audio") {
            try { utilizador.audioTrack?.play(); } catch (eAudio) { console.log(eAudio); }
          }
        },
        aoDespublicarRemoto: (utilizador, tipoMedia) => {
          // Só tira o anfitrião do ecrã se for o VÍDEO a sair; silenciar o
          // microfone não pode apagar a câmara.
          if (tipoMedia === "video") {
            setUtilizadoresRemotos((prev) => prev.filter(u => u.uid !== utilizador.uid));
          }
        },
      });

      if (resultado.ok && souODono) {
        const pistaAudio = ligacao.sessao.audio;
        const pistaVideo = ligacao.sessao.video;
        try { await pistaAudio?.setEnabled(true); } catch (eEn) { console.log(eEn); }
        try { await pistaAudio?.setMuted(false); } catch (eMt) { console.log(eMt); }
        audioTrackRef.current = pistaAudio || null;
        setStreamLocal(pistaVideo || null);
        setMicAtivo(true);
        console.log("Anfitrião no ar: áudio + vídeo publicados.", { audio: !!pistaAudio, video: !!pistaVideo });
      }
      if (!resultado.ok) {
        audioTrackRef.current = null;
        setStreamLocal(null);
      }
    };

    entrarNaLive();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idCanalEfetivo, emLive, ligacao.tentativa]);

      // FUNÇÃO DE ADESÃO VITALÍCIA À CLAQUE OFICIAL (CHAMADA SEGURA AO SERVIDOR)
  const comprarAbonoClaque = async () => {
    // Garante que temos o ID do canal e o visitante legítimo
    const canalIdStreamer = idCanalEfetivo || idCanalLiveProp;
    if (!canalIdStreamer || !meuId) return;

    try {
      // Importa a ferramenta do Firebase necessária para chamar funções do servidor
      const { getFunctions, httpsCallable } = await import('firebase/functions');
      const functionsInstance = getFunctions(undefined, "europe-west1");
      const chamarFuncaoClaque = httpsCallable(functionsInstance, "processarClaqueLiveCampoSegura");

      // Envia os dados necessários para o servidor processar a transação bancária
      const resposta = await chamarFuncaoClaque({
        idCanalEstudio: idCanalEfetivo,
        uidStreamerApoiar: canalIdStreamer
      });

      // Se o servidor deu luz verde, ativa o sucesso no ecrã do utilizador
      if (resposta.data && resposta.data.sucesso) {
        setEuPertencoAClaque(true);
        setMoedasClaqueSessao(prev => prev + 100);
        alert("Bem-vindo à Claque Oficial! 📣🏟️");
      }
    } catch (errC) {
      // Se o servidor rejeitar por falta de dinheiro, apanha o erro aqui
      if (errC.message === "SALDO_INSUFICIENTE" || errC.message?.includes("SALDO_INSUFICIENTE")) {
        alert("Saldo insuficiente para entrar na Claque Oficial! ⚽");
      } else {
        alert("Erro ao entrar na claque oficial. Tente novamente mais tarde.");
        console.error("Erro na auditoria da claque oficial:", errC);
      }
    }
  };

  const dispararPresente = async (precoBolas, presenteNome, videoUrl, tipoOpcao = 'normal') => {
    try {
      // 0. SANIDADE DOS DADOS DO CROMO: previne "undefined freezes" — um cromo com
      // preço em falta provocava saldoBolas - undefined = NaN e travava a gravação.
      const precoNumerico = Number(precoBolas);
      if (!Number.isFinite(precoNumerico) || precoNumerico <= 0) {
        console.error("Preço de presente inválido, envio cancelado:", precoBolas);
        return;
      }
      precoBolas = precoNumerico;

      // 1. TRANCA DE SEGURANÇA REGULAMENTAR: valida contra o saldo que está MESMO no
      // servidor neste instante, e não contra o número que o ecrã tem em memória.
      const meuUserRef = doc(db, "utilizadores", meuId);
      const meuSnapAtual = await getDoc(meuUserRef);
      const saldoAtualBolas = Number(meuSnapAtual.data()?.saldoBolas) || 0;

      if (saldoAtualBolas < precoBolas) {
        alert("Saldo insuficiente! ⚽");
        return;
      }

      // 2. RETIRAR OS PONTOS A QUEM ENVIA
      // Antes gravava-se o total absoluto calculado a partir do estado do React.
      // Agora quem subtrai diretamente no servidor de forma segura é a nossa função.
      await moverSaldo(meuId, { bolas: -precoBolas });
    
              // ========================================================
        // ENVIAR XP AUTOMÁTICO - DISPARAR PRESENTE (LIVES)
        // ========================================================
        if (meuId) {
          adicionarXP(meuId, 'adepto', precoBolas);
        }
        const idStreamerAlvo = emLive ? meuId : idCanalEfetivo;
        if (idStreamerAlvo && idStreamerAlvo !== meuId) {
          adicionarXP(idStreamerAlvo, 'jogador', precoBolas);
        }
        // ========================================================

      // O ecrã não é corrigido à mão: o `onSnapshot` do saldo já está ligado a
      // este documento e recebe o novo valor sozinho.

      // Definir quem é o alvo (quem recebe os pontos e o sticker)
      const idAlvo = emLive ? meuId : idCanalEfetivo;

      if (idAlvo) {
        // 3. ENTRADA DE RECURSOS A QUEM RECEBE NA LIVE COM MOTOR TURBO DE 24H
        const alvoUserRef = doc(db, "utilizadores", idAlvo);
        const alvoSnap = await getDoc(alvoUserRef);
        
        if (alvoSnap.exists()) {
          const dadosAlvo = alvoSnap.data();
          
          // AUDITORIA DO MODO TURBO DE 24 HORAS (CONCLUÍDO DA CADERNETA)
          let rácioStreamerNormal = 0.65;
          let rácioAppNormal = 0.35;
          
          if (dadosAlvo?.cadernetaConcluidaEm) {
            const agoraUnix = Date.now();
            const concluidaEmUnix = typeof dadosAlvo.cadernetaConcluidaEm.toMillis === 'function' 
              ? dadosAlvo.cadernetaConcluidaEm.toMillis() 
              : Number(dadosAlvo.cadernetaConcluidaEm) || 0;
              
            const vinteQuatroHorasEmMs = 24 * 60 * 60 * 1000; // 86.400.000 ms
            
            // Se o tempo atual for menor que o tempo de conclusão + 24 horas, ATIVA O MODO TURBO
            if (agoraUnix < (concluidaEmUnix + vinteQuatroHorasEmMs)) {
              rácioStreamerNormal = 0.75; // 🚀 Streamer ganha bónus de 75%
              rácioAppNormal = 0.25;      // 📉 Estádio reduz taxa de manutenção para 25%
            }
          }

          // 4. UNIFICAÇÃO DA DIVISÃO PARA TODOS OS PRESENTES (STICKERS E MP4)
          const fatiaStreamer = rácioStreamerNormal; // Sempre 0.65 (ou 0.75 no Modo Turbo)
          const fatiaApp = rácioAppNormal;           // Sempre 0.35 (ou 0.25 no Modo Turbo)

          // A) ENTREGA A PARTE DO CRIADOR DIRETAMENTE NO SALDO DELE
          await moverSaldo(idAlvo, {
            bolas: precoBolas * fatiaStreamer
          });

                    // B) TRANSFERE A TAXA DE MANUTENÇÃO DIRETA PARA O BANCO CENTRAL DO ADMINISTRADOR
          const idAdminFixo = "wkvSZZR5zdUvweoBuydAept6eOn1";
          
          if (tipoOpcao === 'trevo') {
            // 🍀 Se for um Sticker/Cromo, vai para a gaveta exclusiva de Stickers
            await moverSaldo(idAdminFixo, {
              comissaoStickersBolas: precoBolas * fatiaApp
            });
          } else {
            // 🎁 Se for um presente MP4/Vídeo, vai para a gaveta exclusiva de Presentes de Vídeo
            await moverSaldo(idAdminFixo, {
              comissaoPresentesVideoBolas: precoBolas * fatiaApp
            });
          }

                    // 2.5 DESBLOQUEIA O CROMO NA CADERNETA DO STREAMER EM TEMPO REAL E AUDITA FIM DO ÁLBUM
          if (typeof obterListaCompleta50Cromos === 'function') {
            const listaMestre = obterListaCompleta50Cromos();
            const cromoEncontrado = listaMestre.find(c => c.nome === presenteNome);
            
                        // TRANCA SUPREMA: tipoOpcao === 'trevo' garante que presentes mp4 nunca entram na caderneta
            if (cromoEncontrado && idAlvo && tipoOpcao === 'trevo') {
              
              // 🎯 COPIADO DO FEED: Converte dinamicamente 101-150 para 1-50
              const idDoItem = cromoEncontrado.cromoNumero || cromoEncontrado.id;
              const idDoCromoNoAlbum = String(Number(idDoItem) > 100 ? Number(idDoItem) - 100 : idDoItem);
              
              const cromoDonoRef = doc(db, "utilizadores", idAlvo, "caderneta_stickers", idDoCromoNoAlbum);
              
              // 🎯 COPIADO DO FEED: Grava exatamente com a estrutura que ativa as luzes verdes no perfil!
              await setDoc(cromoDonoRef, {
                desbloqueado: true,
                id: Number(idDoCromoNoAlbum),
                nome: presenteNome || "Sticker",
                quantidade: 1,
                ganhoEm: serverTimestamp()
              }, { merge: true }).catch(e => console.error("Erro ao trancar cromo na live:", e));

                        // 🔥 DETETOR ATÓMICO: Controla o Modo Turbo e executa o Reset Automático de 24h
          try {
            const { collection: fColl, getDocs: fGetDocs, doc: fDoc, getDoc: fGetDoc, updateDoc: fUpdateDoc, deleteDoc: fDeleteDoc } = await import('firebase/firestore');
            
            const streamerPerfilRef = fDoc(db, "utilizadores", idAlvo);
            const streamerSnap = await fGetDoc(streamerPerfilRef);
            const dadosStreamer = streamerSnap.data();
            
            const agoraUnix = Date.now();
            const vinteQuatroHorasEmMs = 24 * 60 * 60 * 1000; // 86.400.000 ms
            
            // 🔄 TRANCA DE RESET AUTOMÁTICO: Se o Modo Turbo já expirou, limpa a caderneta para 0/50
            if (dadosStreamer?.cadernetaConcluidaEm) {
              const concluidaEmUnix = typeof dadosStreamer.cadernetaConcluidaEm.toMillis === 'function'
                ? dadosStreamer.cadernetaConcluidaEm.toMillis()
                : Number(dadosStreamer.cadernetaConcluidaEm) || 0;
                
              if (agoraUnix >= (concluidaEmUnix + vinteQuatroHorasEmMs)) {
                // 1. Apaga o carimbo do Modo Turbo no perfil para permitir uma nova ativação no futuro
                await fUpdateDoc(streamerPerfilRef, {
                  cadernetaConcluidaEm: null
                });
                
                // 2. Pulveriza todos os documentos da subcoleção de cromos do utilizador de forma atómica
                const cadernetaCollRef = fColl(db, "utilizadores", idAlvo, "caderneta_stickers");
                const snapCromosVelhos = await fGetDocs(cadernetaCollRef);
                const promessasDeApagar = snapCromosVelhos.docs.map(documento => fDeleteDoc(documento.ref));
                await Promise.all(promessasDeApagar);
                
                console.log("🔄 CADERNETA RESETADA! Prazo de 24h expirado. Álbum voltou a 0/50 para o próximo ciclo de jogo!");
              }
            }
            
            // 🚀 GATILHO DE ATIVAÇÃO: Verifica se com o cromo atual atingiu os 50/50 pela primeira vez
            const cadernetaCollRef = fColl(db, "utilizadores", idAlvo, "caderneta_stickers");
            const snapCaderneta = await fGetDocs(cadernetaCollRef);
            
            if (snapCaderneta.size === 50) {
              // Recarrega o snapshot atualizado caso o reset tenha ocorrido acima
              const streamerSnapAtualizado = await fGetDoc(streamerPerfilRef);
              if (!streamerSnapAtualizado.data()?.cadernetaConcluidaEm) {
                await fUpdateDoc(streamerPerfilRef, {
                  cadernetaConcluidaEm: serverTimestamp()
                });
                console.log("🚀 MODO TURBO ATIVADO! 75%/25% libertado por 24h.");
              }
            }
          } catch (errAuditoria) {
            console.error("Erro na auditoria e reset da caderneta:", errAuditoria);
          }

            }
          }
        }

      // 1. Sincronizar os estados locais imediatamente para quem envia
        setMoedasAcumuladasLive(prev => prev + precoBolas);

        // 2. ATIVAR A ANIMAÇÃO DO STICKER E GRAVAR OS TOTAIS GLOBAIS NO SERVIDOR (ATUALIZA TODOS OS TELEMÓVEIS)
        // 2.6 DISPARA A ANIMAÇÃO DO CROMO PARA A SUBCOLEÇÃO EM TEMPO REAL (CÓPIADA DA SALA)
        if (tipoOpcao === 'trevo' && idAlvo) {
          try {
            const liveAnimRef = collection(db, "utilizadores", idAlvo, "animacoes_caderneta");
            await addDoc(liveAnimRef, {
              videoUrl: videoUrl,
              presenteNome: presenteNome,
              deNome: auth.currentUser?.displayName || "Adepto",
              criadoEm: serverTimestamp()
            });
          } catch (errAnim) { console.error("Erro na animação do trevo:", errAnim); }
        }

        const liveDocRef = doc(db, "lives_activas", idCanalEfetivo);
        await updateDoc(liveDocRef, {
          presenteAnimacao: videoUrl,
          presenteTexto: presenteNome,
          presenteRemetenteUid: meuId,
          presenteRemetenteNome: auth.currentUser?.displayName || "Um craque",
          ultimoPresenteEm: serverTimestamp(),
          totalMoedasLive: increment(precoBolas)
        });

        // 5. MOTOR DE RANKING DO PÓDIO EM TEMPO REAL (PRINT 6)
        // Grava no canal do streamer (idAlvo = emLive ? meuId : idCanalLive), o mesmo
        // que os letreiros/painel escutam — antes usava idCanalLive e rebentava p/ o Dono.
        const rankingRef = doc(db, "lives_activas", idAlvo, "ranking", meuId);
        const nomeRemetente = dadosUtilizador?.nomeCompleto || auth.currentUser?.displayName || "Adepto";
        // Incremento ATÓMICO no servidor: dois envios rápidos do mesmo adepto nunca se
        // sobrepõem (o read-then-write antigo perdia totais durante gifting concorrente).
        await updateDoc(rankingRef, {
          totalGasto: increment(precoBolas),
          ultimoEnvio: serverTimestamp(),
          nomeCompleto: nomeRemetente,
          nome: nomeRemetente,
          foto: auth.currentUser?.photoURL || ""
        }).catch(async () => {
          // Documento ainda não existe: cria-o de raiz com o total inicial.
          await setDoc(rankingRef, {
            totalGasto: precoBolas,
            ultimoEnvio: serverTimestamp(),
            nomeCompleto: nomeRemetente,
            nome: nomeRemetente,
            foto: auth.currentUser?.photoURL || ""
          });
        });

        // // NOTA: os totais de BOLAS da Live já foram incrementados atomicamente na gravação
        // do presente acima — a 2ª escrita redundante (que reescrevia com estado local
        // desatualizado) foi removida para não anular o valor correto do servidor.

              // 6. INJETAR A MENSAGEM DO PRESENTE OU CROMO DIRETA NO CHAT PÚBLICO (DIFERENCIAÇÃO DE EMOJI)
        const chatRef = collection(db, "lives_activas", idCanalEfetivo, "chat");
        await addDoc(chatRef, {
          // 🍀 Se for do tipo trevo, mostra o trevo no chat. Se for presente normal, mostra a caixinha 🎁
          texto: tipoOpcao === 'trevo' ? `doou o ${presenteNome} 🍀` : `enviou ${presenteNome} 🎁`,
          tipo: "presente",
          uid: meuId,
          nome: auth.currentUser?.displayName || "Adepto",
          foto: auth.currentUser?.photoURL || "",
          criadoEm: serverTimestamp()
        });
      }

      setMostrarPresentes(false); // Fecha a gaveta de presentes
    } catch (errPresente) {
      console.error("Erro ao processar transação do presente:", errPresente);
    }
  };

  // =========================================================================
  // 🎡 MOTOR UNIFICADO GERAL: PROCESSO DE ENVIO DE LUCKYS E PRESENTES LIVE
  // =========================================================================
  const processarEnvioPresente = async (presente, destinatario) => {
    const meuId = auth.currentUser?.uid;
    const idDaSalaDestino = idCanalEfetivo || auth.currentUser?.uid;
    if (!presente || !destinatario || !meuId || !idDaSalaDestino) return;

    try {
      const qtdMultiplicador = presente.tipo === 'lucky' ? (presente.quantidade || quantidadeSelecionada || 1) : 1;
      const custoTotalPresenteBolas = presente.preco * qtdMultiplicador;
      
      const meuRef = doc(db, "utilizadores", meuId);
      const meuSnap = await getDoc(meuRef);
      const meuSaldoB = meuSnap.data()?.saldoBolas || 0;

      if (meuSaldoB < custoTotalPresenteBolas) {
        alert("Saldo insuficiente para esta quantidade! ⚽");
        return;
      }

      let totalPremioBolas = 0;
      let maiorMultiplicadorGanho = 0;
      let vezesGanhou = 0;

          // Loop de combos para luckys migrado para o servidor com Blindagem Máxima
      if (presente.tipo === 'lucky') {
                const { getFunctions, httpsCallable } = await import('firebase/functions');
        // Usamos a região 'europe-west1' porque o teu servidor está configurado em Lisboa/Europa!
        const functionsInstance = getFunctions(undefined, 'europe-west1');
        const chamarLuckyNoServidor = httpsCallable(functionsInstance, 'processarLuckyLiveSoloSegura');

        try {
          // 1. Importa a autenticação para conseguir ler a sessão atual do telemóvel
const { getAuth } = await import('firebase/auth');
const authInstance = getAuth();
const utilizadorAtual = authInstance.currentUser;

// 2. Gera o token de segurança em tempo real
const tokenDeSeguranca = utilizadorAtual ? await utilizadorAtual.getIdToken(true) : null;

// 3. Dispara os dados para o servidor incluindo o token explícito
      const respostaServidor = await chamarLuckyNoServidor({
        presenteLucky: presente,
        idCanalEstudio: idCanalLiveProp,
        quantidadeCombo: qtdMultiplicador,
        uidStreamerApoiar: destinatario.uid,
        luckyId: presente.id
      });

          // Puxa as variáveis de resposta para as animações continuarem a funcionar
          totalPremioBolas = respostaServidor.data.totalPremioBolas;
          maiorMultiplicadorGanho = respostaServidor.data.maiorMultiplicadorGanho;
          vezesGanhou = respostaServidor.data.vezesGanhou;

        } catch (errServidor) {
          alert(errServidor.message || "Erro ao rodar o Lucky.");
          return;
        }
      }

      // Deduz o custo total e injeta o prémio ganho de forma líquida e imediata no jogador
      const { updateDoc: fUpdateDoc, increment: fIncrement, doc: fDoc, setDoc: fSetDoc } = await import('firebase/firestore');
      
              // O saldo final do jogador retira o custo do bilhete e soma o prémio ganho diretamente
        const saldoFinalModificado = -custoTotalPresenteBolas + totalPremioBolas;

        // ========================================================
        // ENVIAR XP AUTOMÁTICO - PROCESSAR ENVIO PRESENTE (LIVES)
        // ========================================================
        const meuUidInLive = auth?.currentUser?.uid;
        if (meuUidInLive) {
          adicionarXP(meuUidInLive, 'adepto', custoTotalPresenteBolas);
        }
        if (destinatario?.uid && destinatario.uid !== meuUidInLive) {
          adicionarXP(destinatario.uid, 'jogador', custoTotalPresenteBolas);
        }
        // ========================================================

            // processamento de divisão de lucro e alimentação do cofre da live
      if (presente.tipo === 'lucky') {
        // O servidor já processou os saldos de forma blindada!
        console.log("Luckys processados via Cloud Functions com sucesso.");

      } else {
        // 👑 TRANCA DO CASHBACK: Regista no ranking usando a variável correta que os outros botões usam!
        const meuRankingRef = fDoc(db, "lives_activas", idDaSalaDestino, "ranking", meuId);
        await fSetDoc(meuRankingRef, {
          nomeCompleto: auth.currentUser?.displayName || "Adepto",
          totalGasto: fIncrement(custoTotalPresenteBolas)
        }, { merge: true }).catch((errRk) => console.error("Erro ao fundir ranking do top:", errRk));

        // 🎥 LIVES A SOLO: Aplica 65% líquidos das Bolas diretamente para o Streamer
        const ganhoStreamerBolas = Math.round(custoTotalPresenteBolas * 0.65);
        await fUpdateDoc(doc(db, "utilizadores", destinatario.uid), {
          saldoBolas: fIncrement(ganhoStreamerBolas)
        }).catch(() => {});

        // 👑 ADMINISTRAÇÃO MESTRE: Retém os 35% brutos
        const meuIdAdminMestre = "wkvSZZR5zdUvweoBuydAept6eOn1";
        const comissaoAdminBolas = Math.round(custoTotalPresenteBolas * 0.35);
        const campoComissao = (presente.tipoPresente === 'sticker' || presente.tipo === 'sticker')
          ? "comissaoStickersBolas" : "comissaoPresentesVideoBolas";

        await fUpdateDoc(doc(db, "utilizadores", meuIdAdminMestre), {
          [campoComissao]: fIncrement(comissaoAdminBolas)
        }).catch(() => {});

        // 📈 SINCRONIZAÇÃO TOTAL: Atualiza o acumulado do documento usando idCanalEfetivo!
        await fUpdateDoc(fDoc(db, "lives_activas", idCanalEfetivo), {
          totalMoedasLive: fIncrement(custoTotalPresenteBolas)
        }).catch((errAct) => console.error("Erro ao atualizar moedas da live activa:", errAct));
      }

      // dispara o sinal da animação em direto na live (Alinhado com a coleção legítima lives_activas)
      const animRef = collection(db, "lives_activas", idDaSalaDestino, "animacoes_presentes");
      
      const ehVideo = /\.(mp4|webm|mov)(\?|#|\$)/i.test(presente.video || "");
      
      const docAnimacao = await addDoc(animRef, {
        videoUrl: presente.video || "",
        iconeUrl: presente.icone || "",
        posterUrl: presente.icone || "",
        presenteNome: presente.nome,
        tipo: presente.tipo || presente.tipoPresente || "", 
        ehVideo: ehVideo,
        deUid: meuId,
        deNome: auth.currentUser?.displayName || "Adepto",
        deFoto: auth.currentUser?.photoURL || "",
        paraUid: destinatario.uid,
        paraNome: destinatario.nome || "Streamer",
        criadoEm: serverTimestamp(),
        isLucky: presente.tipo === 'lucky',
        quantidadeCombo: qtdMultiplicador,
        multiplicador: maiorMultiplicadorGanho,
        totalGanhoBolas: totalPremioBolas,
        ganhouLucky: totalPremioBolas > 0
      });

      await updateDoc(docAnimacao, { id: docAnimacao.id, chave: docAnimacao.id }).catch(() => {});

      // feedback na interface de utilizador
      if (presente.tipo === 'lucky') {
        if (totalPremioBolas > 0) {
          setAvisoPresente(`⚡ LUCKYS: Rodaste ${qtdMultiplicador}x! O teu maior multiplicador foi de ${maiorMultiplicadorGanho}x. Ganhaste ${totalPremioBolas.toLocaleString()} ⚽!`);
        } else {
          setAvisoPresente(`⚡ LUCKYS: Rodaste ${qtdMultiplicador}x mas a sorte não esteve contigo! Tenta de novo. 🔥`);
        }
        setQuantidadeSelecionada(1);
      }

      setComboPresenteAtivo(presente);
      setComboDestinatarioAtivo(destinatario);
      
      // 🎯 Alinhamento Sagrado: A primeira carga assume o valor cheio enviado (ex: 10)
      const novoValorAcumulado = contagemComboCliques === 0 ? qtdMultiplicador : (contagemComboCliques + qtdMultiplicador);
      setContagemComboCliques(novoValorAcumulado);
      setMostrarBolinhaRosa(true);

      if (window.timerComboLive) clearTimeout(window.timerComboLive);
      window.timerComboLive = setTimeout(() => {
        setMostrarBolinhaRosa(false);
        setContagemComboCliques(0);
      }, 3000);

      // O anúncio apaga-se sozinho passados 25 s para poupar a base de dados
      setTimeout(() => {
        import('firebase/firestore').then(({ doc: fDoc, deleteDoc: fDeleteDoc }) => {
          fDeleteDoc(fDoc(db, "lives_activas", idDaSalaDestino, "animacoes_presentes", docAnimacao.id)).catch(() => {});
        });
      }, 25000);

          // 6. INJETAR NO CHAT APENAS SE FOR VIDEO OU STICKER (Luckys ficam trancadas e fora do chat!)
      if (presente.tipo !== 'lucky' && presente.tipoPresente !== 'lucky') {
        const chatRef = collection(db, "lives_activas", idCanalEfetivo, "chat");
        await addDoc(chatRef, {
          texto: tipoOpcao === 'trevo' || presente.tipo === 'sticker' || presente.tipoPresente === 'sticker'
            ? `doou o ${presente.nome || presenteNome} 🍀` 
            : `enviou ${presente.nome || presenteNome} 🎁`,
          tipo: "presente",
          uid: meuId,
          nome: auth.currentUser?.displayName || "Adepto",
          foto: auth.currentUser?.photoURL || "",
          criadoEm: serverTimestamp()
        });
      }
    } catch (err) {
      console.error("Erro no processamento mestre do presente da Live:", err);
    }
  };

  return (
    <div
      className="notranslate"
      translate="no"
      style={{
      position: 'fixed',
      inset: 0,
      background: `url(${imgfundoAudio}) center/cover no-repeat`,
      zIndex: 999,
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'sans-serif',
      overflow: 'hidden'
    }}>

                      {/* COMPONENTE 12: FEED FLUTUANTE DE COMBOS EM TEMPO REAL (ESTILO TIKTOK / ALII) */}
        {listaAvisosFeed.length > 0 && (
          <div style={{ position: 'fixed', bottom: '350px', left: '15px', display: 'flex', flexDirection: 'column', gap: '12px', zIndex: 110000, pointerEvents: 'none', maxWidth: '85vw' }}>
            {listaAvisosFeed.map((card) => {
              const ganhouGrande = card.multiplicadorGanho > 1;
              return (
                <div key={card.id} style={{ display: 'flex', alignItems: 'center', backgroundColor: 'transparent', gap: '10px', animation: 'fadeInLeft 0.2s ease-out' }}>
                  <img src={card.fotoRemetente || '/hero.png'} alt="perfil" style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1.5px solid #FFD700', objectFit: 'cover', boxShadow: '0 2px 8px rgba(0,0,0,0.5)' }} />
                  <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2', textShadow: '1px 1px 3px rgba(0,0,0,0.8)' }}>
                    <span style={{ color: '#FFF', fontSize: '13px', fontWeight: 'bold' }}>{card.nomeRemetente}</span>
                    <span style={{ color: '#ccc', fontSize: '10px', fontWeight: '500' }}>Enviar ➡️ {card.nomeDestinatario}</span>
                    <span style={{ 
                      color: ganhouGrande ? '#39FF14' : '#FFD700', 
                      fontSize: '11px', 
                      fontWeight: '900', 
                      animation: ganhouGrande ? 'pulse 0.5s infinite alternate' : 'none', 
                      textShadow: ganhouGrande ? '0 0 8px #39FF14' : '1px 1px 2px rgba(0,0,0,0.9)' 
                    }}>
                      {card.isLucky ? ` Recebeu ${card.multiplicadorGanho}X = ${card.totalGanhoBolas} ⚽ ` : ` Enviou ${card.presenteNome} 🍀 `}
                    </span>
                  </div>
                  {card.presenteIcone && <img src={card.presenteIcone} alt="item" style={{ width: '26px', height: '26px', objectFit: 'contain', marginLeft: '5px', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }} />}
                  <span style={{ color: '#FFF', fontSize: '22px', fontWeight: '950', fontFamily: 'system-ui, sans-serif', fontStyle: 'italic', marginLeft: '6px', textShadow: '2px 2px 4px #000, 0 0 8px rgba(255,255,255,0.2)' }}>
                    x{card.uidRemetente === meuId ? contagemComboCliques : card.quantidadeCombo}
                  </span>
                </div>
              );
            })}
          </div>
        )}

              {/* COMPONENTE 14: MODAL PREMIUM DE SELEÇÃO DE LUCKYS BAÚS */}
        {mostrarMenuLuckys && (
          <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 115000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ position: 'relative', background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', padding: '16px', borderRadius: '25px', border: '2px solid #FFD700', boxShadow: '0 12px 40px rgba(0, 0, 0, 0.6), 0 0 25px rgba(255, 215, 0, 0.25)', width: '92%', maxWidth: '410px', boxSizing: 'border-box' }}>
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <h3 style={{ color: '#FFD700', margin: 0, fontWeight: '900', fontSize: '14px', letterSpacing: '1px', textTransform: 'uppercase', textShadow: '0 0 10px rgba(255, 215, 0, 0.4)' }}>LUCKYS ⚡</h3>
                  {/* Botão de interrogação que ativa visualmente a gaveta de regras embutida */}
                  <button 
                    onClick={() => {
                      const elemRegras = document.getElementById("subModalRegrasLuckys");
                      if (elemRegras) elemRegras.style.display = "block";
                    }} 
                    style={{ background: 'none', border: 'none', fontSize: '15px', cursor: 'pointer', padding: '0 4px', display: 'flex', alignItems: 'center' }}
                  >
                    ❓
                  </button>
                </div>
                <button onClick={() => setMostrarMenuLuckys(false)} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFD700', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer' }}>✕</button>
              </div>

              {/* GAVETA INTERNA DE REGRAS MANDATÓRIAS PARA EVITAR REJEIÇÕES NA PLAYSTORE E APPSTORE */}
              <div id="subModalRegrasLuckys" style={{ display: 'none', position: 'absolute', inset: 0, backgroundColor: 'rgba(10,15,20,0.98)', zIndex: 116000, padding: '16px', borderRadius: '25px', color: '#fff', textAlign: 'left', overflowY: 'auto', boxSizing: 'border-box', border: '2px solid #FFD700' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '6px' }}>
                  <h4 style={{ margin: 0, color: '#FFD700', fontSize: '12px', fontWeight: '900' }}>🎡 REGRAS DO PRESENTE DA SORTE</h4>
                  <button onClick={() => { const el = document.getElementById("subModalRegrasLuckys"); if (el) el.style.display = "none"; }} style={{ background: '#FFD700', border: 'none', borderRadius: '6px', padding: '2px 8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '10px', color: '#000' }}>FECHAR</button>
                </div>
                <div style={{ fontSize: '11px', lineHeight: '1.4', display: 'flex', flexDirection: 'column', gap: '8px', color: '#e0e0e0' }}>
                  <p><strong>1. Funcionamento:</strong> O utilizador adquire e envia Presentes da Sorte através do seu saldo de Bolas, obtendo uma probabilidade aleatória de reaver recompensas com valores multiplicados.</p>
                  <p><strong>2. Saldo Líquido Imediato:</strong> Todas as recompensas ganhas entram instantaneamente como saldo real na sua carteira, ficando 100% livres e disponíveis para levantamento imediato via transferência bancária, sem bloqueios ou trocas burocráticas.</p>
                  <p><strong>3. Probabilidades Regulares:</strong><br />
                    Perder (0x): 60.89% | Retorno (1x): 22.00% | Dobro (2x): 11.50% | 5x: 3.00% | 10x: 2.00% | 20x: 0.50% | 50x: 0.10% | 100x: 0.01%.<br />
                    <span style={{ color: '#888' }}>(RTP Geral Estável: 96%).</span>
                  </p>
                  <p><strong>4. Canal de Caça-Jackpot 1000X (Apito e Capitão):</strong><br />
                    Perder (0x): 99.904% | Prémio Supremo (1000x): 0.096%.<br />
                    <span style={{ color: '#888' }}>(RTP Geral Estável: 96%).</span>
                  </p>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', padding: '0', height: '260px', maxHeight: '260px', overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch' }}>
                {LISTA_LUCKYS.map((pres) => {
                  const estaSelecionado = presenteSelecionado?.id === pres.id;
                  return (
                    <div key={pres.id} onClick={() => { setPresenteSelecionado(pres); setUltimoLuckyEnviado(pres); }} style={{ textAlign: 'center', cursor: 'pointer', padding: '6px 4px', background: estaSelecionado ? 'rgba(255, 215, 0, 0.1)' : 'rgba(255, 255, 255, 0.03)', border: estaSelecionado ? '2px solid #FFD700' : '1px solid rgba(255, 255, 255, 0.06)', borderRadius: '12px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s ease', boxSizing: 'border-box' }}>
                      <div style={{ width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '4px' }}><img src={pres.icone} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} alt={pres.nome} loading="lazy" /></div>
                      <p style={{ color: '#FFF', fontSize: '8px', fontWeight: 'bold', margin: '0 0 2px 0', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>{pres.nome}</p>
                      <p style={{ color: '#FFD700', fontSize: '9px', fontWeight: '900', margin: 0, fontFamily: 'monospace' }}>⚽ {pres.preco}</p>
                    </div>
                  );
                })}
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <select value={quantidadeSelecionada} onChange={(e) => setQuantidadeSelecionada(Number(e.target.value))} style={{ backgroundColor: 'rgba(0,0,0,0.5)', color: '#FFD700', border: '1px solid #FFD700', padding: '6px 24px 6px 12px', borderRadius: '12px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', appearance: 'none', outline: 'none' }}>
                    <option value={1}>1</option>
                    <option value={10}>10</option>
                    <option value={99}>99</option>
                    <option value={188}>188</option>
                    <option value={999}>999</option>
                    <option value={1888}>1888</option>
                    <option value={2999}>2999</option>
                  </select>
                  <span style={{ color: '#FFD700', fontSize: '10px', position: 'absolute', right: '10px', pointerEvents: 'none' }}>▼</span>
                </div>

                <button 
                  onClick={() => {
                    if (!presenteSelecionado) { alert("Por favor, seleciona primeiro um item Lucky!"); return; }
                    
                    // 🛡️ TRANCA SUPREMA ANTI-AUTODOAÇÃO: Streamer/Anfitrião não pode jogar Luckys na própria Live
                    if (auth.currentUser?.uid === idCanalEfetivo) {
                      alert("Como anfitrião, não podes jogar Luckys na tua própria transmissão! 🏟️❌");
                      return;
                    }

                    const alvoFinal = { 
                      uid: idCanalEfetivo, 
                      nome: dadosUtilizador?.nomeCompleto || "Streamer" 
                    };

                    processarEnvioPresente({ 
                      ...presenteSelecionado, 
                      quantidade: quantidadeSelecionada || 1,
                      tipo: 'lucky',
                      tipoPresente: 'lucky'
                    }, alvoFinal);
                    
                    setMostrarMenuLuckys(false);
                  }} 
                  style={{ backgroundColor: '#00B359', color: 'white', border: 'none', padding: '8px 24px', borderRadius: '12px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0, 179, 89, 0.3)' }}
                >
                  Enviar
                </button>
              </div>
            </div>
          </div>
        )}

      {/* A ENTRAR / ERRO DE LIGAÇÃO (câmara negada, ocupada, ou 15s sem entrar) */}
      <EstadoLigacaoEstadio
        estado={ligacao.estado}
        mensagemErro={ligacao.mensagemErro}
        aoTentarDeNovo={ligacao.tentarDeNovo}
        aoSair={typeof aoSair === 'function' ? aoSair : undefined}
      />

      {/* AVISO "TOCAR PARA OUVIR" (só para espetadores quando o browser bloqueia o som) */}
      {!emLive && somBloqueado && (
        <button
          onClick={() => {
            const cliente = ligacao.sessao.cliente;
            if (cliente) {
              cliente.remoteUsers.forEach((u) => { try { u.audioTrack?.play(); } catch (e) { console.log(e); } });
            }
            setSomBloqueado(false);
          }}
          style={{
            position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            zIndex: 1000005, background: '#39FF14', color: '#000', border: 'none',
            borderRadius: '30px', padding: '12px 22px', fontWeight: '900', fontSize: '14px',
            cursor: 'pointer', boxShadow: '0 0 20px rgba(57,255,20,0.6)', display: 'flex',
            alignItems: 'center', gap: '8px'
          }}
        >
          🔊 Toca para ouvir o som
        </button>
      )}

      {/* 1. PLAYER DE VÍDEO PRINCIPAL (REDE EM DIRETO REAL) */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 1, backgroundColor: '#050505' }}>
        {emLive ? (
          streamLocal ? (
          <div id="video-transmissao-local" ref={(el) => { if (el && streamLocal && el.dataset.aTocar !== '1') { el.dataset.aTocar = '1'; reproduzirVideoNoContentor(streamLocal, el); } }} style={{ width: '100%', height: '100%', backgroundColor: '#050505', display: 'block', position: 'relative', overflow: 'hidden' }} />
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#39FF14', fontSize: '13px', fontWeight: 'bold' }}>
              🎥 A INICIALIZAR A TUA CÂMARA EM DIRETO...
            </div>
          )
                ) : (
          /* O VÍDEO QUE VEM DO ANFITRIÃO PARA OS ESPETADORES (BLOCO DO TOSHIBA) */
          <div style={{ width: '100%', height: '100%', backgroundColor: '#000', position: 'relative' }}>
            {utilizadoresRemotos && utilizadoresRemotos.map(remoteUser => (
              <div 
                key={remoteUser.uid} 
                ref={(el) => { if (el && el.dataset.aTocar !== '1' && remoteUser.videoTrack) { el.dataset.aTocar = '1'; reproduzirVideoNoContentor(remoteUser.videoTrack, el); remoteUser.audioTrack?.play(); } }}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
              />
            ))}
            {(!utilizadoresRemotos || utilizadoresRemotos.length === 0) && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#39FF14', gap: '10px' }}>
                <span>⚽</span>
                <span style={{ fontSize: '12px', fontWeight: 'bold' }}>À ESPERA DO SINAL DO ESTÁDIO...</span>
              </div>
            )}
          </div>
        )}
      </div>

      {/* INTERFACE SOBREPOSTA DO ESTÁDIO (Z-INDEX: 10) */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 10, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: 'linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, transparent 20%, transparent 70%, rgba(0,0,0,0.7) 100%)', pointerEvents: 'none' }}>
        
              {/* TOPO DO ESTÁDIO: REGRAS PROFISSIONAIS DE DONO VS ESPETADOR (BLOCO DO TOSHIBA) */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 8px', pointerEvents: 'auto', gap: '4px', width: '100%', boxSizing: 'border-box' }}>
          <div style={{ display: 'flex', gap: '2px', alignItems: 'center', flexWrap: 'nowrap', flex: 1, overflow: 'hidden' }}>
            
                      {/* SISTEMA DINÂMICO: TEXTO REAL OU BOTÃO +SEGUIR PARA ESPETADORES */}
            {auth.currentUser?.uid === idCanalLiveProp ? (
              // Se for o dono, mostra apenas a tag da Live estática
              <div style={{ display: 'flex', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.6)', padding: '4px 8px', borderRadius: '15px', border: '1px solid #39FF14', height: '24px', boxSizing: 'border-box', flexShrink: 0 }}>
                <span style={{ color: '#39FF14', fontWeight: 'bold', fontSize: '10px', marginRight: '4px' }}>●</span>
                <span style={{ color: '#FFF', fontSize: '10px', fontWeight: 'bold', textTransform: 'uppercase' }}>LIVE</span>
              </div>
            ) : (
              // Se for espetador, cruza todos os IDs possíveis contra a lista de seguidos
              (!meusSeguidos || 
               (!meusSeguidos.includes(idCanalLiveProp) && 
                !meusSeguidos.includes(dadosUtilizador?.uid) && 
                !meusSeguidos.includes(dadosUtilizador?.id))) ? (
                <button
                                  onClick={async (e) => {
                  e.stopPropagation();
                  const idAlvo = idCanalLiveProp || dadosUtilizador?.uid || dadosUtilizador?.id;
                  if (!idAlvo || !db) return;
                      try {
      const meuUid = auth.currentUser?.uid;
      if (!meuUid) return;

      const { doc: fDoc, setDoc: fSetDoc, updateDoc: fUpdateDoc, increment: fIncrement } = await import('firebase/firestore');

      // 1. Gravação síncrona nas subcoleções universais em português
      await fSetDoc(fDoc(db, "utilizadores", meuUid, "seguindo", idAlvo), { criadoEm: new Date() });
      await fSetDoc(fDoc(db, "utilizadores", idAlvo, "seguidores", meuUid), { criadoEm: new Date() });

      // 2. Incremento atómico dos contadores no documento principal para atualizar o Perfil na hora
      await fUpdateDoc(fDoc(db, "utilizadores", meuUid), { seguindoCount: fIncrement(1) });
      await fUpdateDoc(fDoc(db, "utilizadores", idAlvo), { seguidoresCount: fIncrement(1) });

      alert('Iniciaste o suporte! Agora segues este craque! ⚽✨');
    } catch (errGlobal) {
      console.error("Erro fatal no protocolo de amizades:", errGlobal);
    }
                }}
                style={{ background: '#39FF14', color: 'black', border: 'none', borderRadius: '15px', padding: '0 10px', fontWeight: '900', fontSize: '10px', cursor: 'pointer', boxShadow: '0 0 8px rgba(57, 255, 20, 0.4)', textTransform: 'uppercase', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
              >
                + SEGUIR
              </button>
              ) : (
                // Se o espetador já seguir o dono, transforma o botão num estado cinzento "✓ SEGUIDO" elegante
                <button
                  disabled={true}
                  style={{ background: '#222', color: '#aaa', border: '1px solid #444', borderRadius: '15px', padding: '0 10px', fontWeight: 'bold', fontSize: '10px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, opacity: 0.9 }}
                >
                  ✓ SEGUIDO
                </button>
              )
            )}

            {/* CONTADOR EM FORMATO OLHINHO NÉON (CLICÁVEL: ABRE A LISTA DE BANCADAS) */}
            <div
              onClick={() => setMostrarListaOnline(true)}
              style={{ background: 'rgba(0,0,0,0.6)', padding: '4px 8px', borderRadius: '15px', display: 'flex', alignItems: 'center', gap: '4px', border: '1px solid #39FF14', boxShadow: '0 0 6px rgba(57, 255, 20, 0.2)', height: '24px', boxSizing: 'border-box', flexShrink: 0, cursor: 'pointer' }}
            >
              <span style={{ fontSize: '12px' }}>👁️</span>
              <span style={{ color: '#39FF14', fontSize: '11px', fontWeight: '900' }}>{totalEspetadores}</span>
            </div>

            {/* BOTÃO DO RANKING DE PRESENTEADORES */}
            <div
              onClick={() => { if (typeof setMostrarJanelaRanking === 'function') setMostrarJanelaRanking(true); }}
              style={{ background: 'rgba(0,0,0,0.6)', padding: '4px 8px', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: '1px solid #39FF14', boxShadow: '0 0 6px rgba(57, 255, 20, 0.2)', height: '24px', boxSizing: 'border-box', flexShrink: 0 }}
            >
              <span style={{ fontSize: '11px', marginRight: '2px' }}>🏆</span>
              <span style={{ color: '#39FF14', fontSize: '10px', fontWeight: '900' }}>TOP</span>
            </div>

            {/* CONTADOR DE TAP TAPS */}
            <div style={{ background: 'rgba(0,0,0,0.6)', padding: '4px 8px', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #FF007F', boxShadow: '0 0 6px rgba(255, 0, 127, 0.2)', height: '24px', boxSizing: 'border-box', flexShrink: 0 }}>
              <span style={{ fontSize: '11px', marginRight: '2px' }}>🔥</span>
              <span style={{ color: '#FF007F', fontSize: '10px', fontWeight: '900' }}>{totalTapTaps}</span>
            </div>

                      {/* PAINEL DA CLAQUE OFICIAL (NÉON CIANO) — COMPACTADO ANTI-CORTE */}
            {(emLive || euPertencoAClaque) ? (
              // ESTADO A: Dono ou membro vitalício — selo passivo (não clicável)
              <div style={{ background: 'rgba(0,0,0,0.6)', padding: '4px 5px', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #00E5FF', boxShadow: '0 0 6px rgba(0, 229, 255, 0.25)', height: '24px', boxSizing: 'border-box', flexShrink: 0 }}>
                <span style={{ color: '#00E5FF', fontSize: '9px', fontWeight: '950', whiteSpace: 'nowrap', letterSpacing: '-0.3px' }}>
                  📣 CLAQUE: {metaClaqueAtingida ? 5000 : Math.min(tapsClaqueAcumulados, 5000)}/5000
                </span>
              </div>
            ) : (
              // ESTADO B: Espetador fora da claque — botão néon clicável
              <div
                onClick={comprarAbonoClaque}
                style={{ background: 'rgba(0,0,0,0.6)', padding: '4px 5px', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: '1px solid #00E5FF', boxShadow: '0 0 6px rgba(0, 229, 255, 0.25)', height: '24px', boxSizing: 'border-box', flexShrink: 0 }}
              >
                <span style={{ color: '#00E5FF', fontSize: '9px', fontWeight: '950', whiteSpace: 'nowrap', letterSpacing: '-0.3px' }}>
                  📣 CLAQUE (100⚽)
                </span>
              </div>
            )}
          </div>

        {/* PAINEL DUPLO INDEPENDENTE NA MESMA LINHA: DESLOCADO PARA BAIXO COM POSITION ABSOLUTE */}
      <div style={{
        position: 'absolute', top: '50px', left: 0, width: '100%',
        display: 'flex', justifyContent: 'space-between', gap: '8px',
        padding: '0 10px', boxSizing: 'border-box', zIndex: 99
      }}>
        {/* CAIXA 1: CONTADOR DE RENDIMENTO DESPORTIVO (AZUL NÉON COM LETRAS BRANCAS) */}
        <div style={{
          flex: 1, background: 'rgba(5, 5, 5, 0.95)', border: '1.5px solid #00F3FF',
          borderRadius: '10px', padding: '5px 8px', overflow: 'hidden', whiteSpace: 'nowrap',
          boxShadow: '0 0 10px rgba(0, 243, 255, 0.25)'
        }}>
          <marquee behavior="scroll" direction="left" scrollamount="3" style={{
            color: '#FFFFFF', fontSize: '10px', fontWeight: '900', fontFamily: 'monospace', display: 'block'
          }}>
          ⚽ ACUMULADO: {Number(moedasAcumuladasLive || 0).toLocaleString()} BOLAS
          </marquee>
        </div>

        {/* CAIXA 2: O REI DO TOP (DOURADO E PRETO COM O LÍDER REAL) */}
        <div style={{
          flex: 1, background: '#FFD700', border: '1.5px solid #000000',
          borderRadius: '10px', padding: '5px 8px', overflow: 'hidden', whiteSpace: 'nowrap',
          boxShadow: '0 0 10px rgba(255, 215, 0, 0.35)'
        }}>
          <marquee behavior="scroll" direction="left" scrollamount="3" style={{
            color: '#000000', fontSize: '10px', fontWeight: '900', fontFamily: 'monospace', display: 'block'
          }}>
            🏆 LÍDER: {nomeLiderLive} VAI EM 1º NO TOP DE PRESENTEADORES!
          </marquee>
        </div>
      </div>

      {/* 🟢 PILHA DE JACKPOTS VIP: VERSÃO ENCURTADA PRETA COM ARO NÉON (ESTILO CASINO CASCAVA) */}
        {window.listaJackpotsVip && window.listaJackpotsVip.length > 0 && (
          <div style={{
            position: 'absolute',
            top: '86px', // Ajustado com precisão para ficar colado por baixo da barra amarela
            right: '10px', // Alinhado perfeitamente à direita, saindo da frente da marquesa azul
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            zIndex: 100005,
            width: 'auto', // Encurtado: Ocupa apenas o tamanho do conteúdo!
            maxWidth: '190px',
            pointerEvents: 'none'
          }}>
            {window.listaJackpotsVip.map((jack) => (
              <div 
                key={jack.id} 
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  backgroundColor: '#000000', // 🎯 Fundo preto opaco absoluto solicitado
                  border: '2px solid #39FF14', // 🎯 Aro néon verde brilhante
                  borderRadius: '12px',
                  padding: '4px 10px',
                  boxShadow: '0 0 15px #39FF14, inset 0 0 4px rgba(57,255,20,0.5)',
                  animation: 'pulse 0.3s infinite alternate'
                }}
              >
                <img 
                  src={jack.foto || '/hero.png'} 
                  alt="Vencedor VIP" 
                  style={{ width: '24px', height: '24px', borderRadius: '50%', border: '1.5px solid #FFF', objectFit: 'cover', flexShrink: 0 }} 
                />
                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.0', textAlign: 'left', overflow: 'hidden' }}>
                  <span style={{ color: '#FFF', fontSize: '9px', fontWeight: '900', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                    {jack.nome}
                  </span>
                  <span style={{ color: '#39FF14', fontSize: '10px', fontWeight: '950', fontStyle: 'italic', textShadow: '0 0 3px #39FF14', whiteSpace: 'nowrap' }}>
                    +{jack.multiplicador}X! ⚡
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

                {/* BOTÃO DE SAÍDA INTELIGENTE EM FORMATO COMPACTO X */}
          <button
            onClick={async () => {
              if (auth.currentUser?.uid === idCanalEfetivo) {
                await encerrarLiveComCashback();
              } else {
                aoSair();
              }
            }}
            style={(() => {
              const souODono = auth.currentUser?.uid === idCanalEfetivo;
              const comum = {
                color: '#FFF', fontSize: '11px', fontWeight: '950', cursor: 'pointer',
                flexShrink: 0, height: '26px', boxSizing: 'border-box',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                lineHeight: 1, whiteSpace: 'nowrap',
              };
              // Dono: a palavra "FECHAR" não cabe num círculo de 26px — ficava
              // "FECHA" com o R cortado. Fica uma pílula vermelha, como os outros
              // botões do topo. Espetador: só o ✕, e aí o círculo serve.
              return souODono
                ? { ...comum, backgroundColor: '#FF3131', border: 'none', borderRadius: '15px',
                    padding: '0 12px', letterSpacing: '0.5px', boxShadow: '0 0 8px rgba(255, 49, 49, 0.4)' }
                : { ...comum, backgroundColor: '#333', border: '1px solid rgba(255,255,255,0.15)',
                    borderRadius: '50%', width: '26px', padding: 0 };
            })()}
          >
            {auth.currentUser?.uid === idCanalEfetivo ? "FECHAR" : "✕"}
          </button>
        </div>

        {/* PARTE DE BAIXO: CHAT FLUIDO E GAVETA DE INTERAÇÕES */}
        <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px', pointerEvents: 'auto' }}>
          
          {/* CAIXA DE CHAT PÚBLICO EM TEMPO REAL */}
                    <div 
            onScroll={(e) => {
              const elemento = e.currentTarget;
              const noFundo = elemento.scrollHeight - elemento.scrollTop <= elemento.clientHeight + 30;
              setUsuarioSubiuScroll(!noFundo);
            }}
            style={{ maxHeight: '200px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px', maskImage: 'linear-gradient(to top, black 80%, transparent 100%)', WebkitMaskImage: 'linear-gradient(to top, black 80%, transparent 100%)' }}
            className="mensagens-scroll"
          >
                        {mensagensLive.map((msg) => {
              const idAutor = msg.uid || msg.userId;
              // Deteta a foto que veio gravada na mensagem, ou usa a foto padrão do estádio
              const fotoAutorChat = msg.foto || msg.fotoUrl || '/hero.png';
              // BRILHO DOURADO EXCLUSIVO: só liga quando a Claque atinge os 5000 taps
              // E quem escreveu é um membro vitalício confirmado da Claque Oficial.
              const membroDaClaqueDourado = metaClaqueAtingida && idAutor && membrosClaqueIds.includes(idAutor);

              return (
                <div key={msg.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: membroDaClaqueDourado ? 'rgba(255, 215, 0, 0.12)' : (msg.tipo === 'presente' ? 'rgba(57, 255, 20, 0.15)' : 'rgba(0,0,0,0.4)'), padding: '6px 12px', borderRadius: '8px', maxWidth: '88%', border: membroDaClaqueDourado ? '1px solid #FFD700' : (msg.tipo === 'presente' ? '1px solid #39FF14' : 'none') }}>

          {/* FOTO REDONDA ESTILO TIKTOK (CLICÁVEL) */}
                  <img
                    src={fotoAutorChat}
                    onClick={() => { if (idAutor) abrirPerfilEspetador(idAutor); }}
                    alt="Perfil"
                    style={{ width: '28px', height: '28px', borderRadius: '50%', border: membroDaClaqueDourado ? '1.5px solid #FFD700' : (msg.tipo === 'presente' ? '1.5px solid #39FF14' : '1.5px solid #FFF'), objectFit: 'cover', cursor: idAutor ? 'pointer' : 'default', flexShrink: 0, boxShadow: membroDaClaqueDourado ? '0 0 8px #FFD700' : 'none' }}
                    onError={(e) => { e.target.src = '/hero.png'; }}
                  />

                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
          {/* NOME CLICÁVEL COM CRACHÁS DE NÍVEL */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                      
                      {/* Crachá de Adepto (Rosa) + Texto do Nível */}
                      {msg.nivelAdepto && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                          <img 
                            src={obterImagemAdepto(msg.nivelAdepto)} 
                            alt={`Adepto Lv ${msg.nivelAdepto}`} 
                            style={{ width: '16px', height: '16px', borderRadius: '50%', border: '1px solid #FF007F', boxShadow: '0 0 4px #FF007F', objectFit: 'cover' }} 
                          />
                          <span style={{ color: '#FF007F', fontSize: '9px', fontWeight: '900', textShadow: '0 0 3px #FF007F', fontFamily: 'sans-serif' }}>
                            Lv.{msg.nivelAdepto}
                          </span>
                        </div>
                      )}

                      {/* Crachá de Jogador (Verde) + Texto do Nível */}
                      {msg.nivelJogador && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                          <img 
                            src={obterImagemJogador(msg.nivelJogador)} 
                            alt={`Jogador Lv ${msg.nivelJogador}`} 
                            style={{ width: '16px', height: '16px', borderRadius: '50%', border: '1px solid #39FF14', boxShadow: '0 0 4px #39FF14', objectFit: 'cover' }} 
                        />
                          <span style={{ color: '#39FF14', fontSize: '9px', fontWeight: '900', textShadow: '0 0 3px #39FF14', fontFamily: 'sans-serif' }}>
                            Lv.{msg.nivelJogador}
                          </span>
                        </div>
                      )}

                      <span
                        onClick={() => { if (idAutor) abrirPerfilEspetador(idAutor); }}
                        style={{ color: membroDaClaqueDourado ? '#FFD700' : '#39FF14', fontWeight: 'bold', fontSize: '13px', cursor: idAutor ? 'pointer' : 'default', textShadow: membroDaClaqueDourado ? '0 0 6px #FFD700, 0 0 12px rgba(255,215,0,0.6)' : 'none' }}
                      >
                        {membroDaClaqueDourado ? '📣 ' : ''}{msg.nome}
                      </span>
                    </div>

                    {/* MENSAGEM */}
                    <span style={{ color: membroDaClaqueDourado ? '#FFD700' : (msg.tipo === 'presente' ? '#39FF14' : '#FFF'), fontSize: '14px', fontWeight: (membroDaClaqueDourado || msg.tipo === 'presente') ? 'bold' : 'normal', textAlign: 'left', textShadow: membroDaClaqueDourado ? '0 0 5px rgba(255,215,0,0.7)' : 'none' }}>
                      {msg.texto}
                    </span>
                  </div>

                </div>
              );
            })}
            <div ref={mensagensEndRef} />
          </div>

          {/* CAIXA DE AÇÕES INFERIORES: RODAPÉ DE ELITE EM LINHA DUPLA (ANTI-CORTES UNIVERSAL) */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%', padding: '0 16px 12px 16px', boxSizing: 'border-box', pointerEvents: 'auto', zIndex: 1000002, marginTop: 'auto' }}>
          
          {/* SE FOR ESPETADOR: REORDENAÇÃO MESTRE DE PATAMARES */}
          {auth.currentUser?.uid !== idCanalEfetivo ? (
            <>
              {/* PATAMAR 1 (SUPERIOR): A BARRA DE INPUT DO CHAT A 100% DA LARGURA */}
              <form 
                                onSubmit={async (e) => {
                    e.preventDefault();
                    const input = e.currentTarget.querySelector('input');
                    if (input && input.value.trim() !== '' && idCanalEfetivo) {
                      try {
                        const textoMsg = input.value;
                        input.value = '';
                        const { collection, addDoc, serverTimestamp } = await import('firebase/firestore');
                        
                        // Mantemos a leitura original que já funcionava para não quebrar nada
                        const fotoReal = auth.currentUser?.photoURL || dadosUtilizador?.fotoUrl || '/hero.png';

                        await addDoc(collection(db, "lives_activas", idCanalEfetivo, "chat"), {
                          texto: textoMsg,
                          userId: auth.currentUser?.uid,
                          uid: auth.currentUser?.uid,
                          nome: auth.currentUser?.displayName || dadosUtilizador?.nomeCompleto || "Craque",
                          foto: fotoReal,
                          tipo: "texto",
                          criadoEm: serverTimestamp(),
                          
                          // Blindado: Se houver userDados ou dadosUtilizador usa o XP, senão envia 0 (Nível 1)
                          nivelAdepto: typeof calcularNivel === 'function' ? calcularNivel(typeof userDados !== 'undefined' ? userDados?.xpAdepto : (dadosUtilizador?.xpAdepto || 0)) : 1,
                          nivelJogador: typeof calcularNivel === 'function' ? calcularNivel(typeof userDados !== 'undefined' ? userDados?.xpJogador : (dadosUtilizador?.xpJogador || 0)) : 1
                        });
                      } catch (errChat) {
                        console.error("Erro ao enviar mensagem para o estádio:", errChat);
                      }
                    }
                  }}

                style={{ width: '100%', display: 'flex', background: 'rgba(0,0,0,0.7)', borderRadius: '25px', padding: '4px 8px', border: '1px solid #222', alignItems: 'center', height: '42px', boxSizing: 'border-box' }}
              >
                <input 
                  type="text" 
                  placeholder="Digita no chat do estádio..." 
                  style={{ flex: 1, background: 'none', border: 'none', color: 'white', padding: '0 12px', fontSize: '13px', outline: 'none' }}
                />
                <button type="submit" style={{ backgroundColor: '#39FF14', color: '#000', border: 'none', width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' }}>➔</button>
              </form>

            {/* PATAMAR 2 (INFERIOR): FILA HORIZONTAL PROFISSIONAL COM INTEGRANTE DE BOLINHA ROSA */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '6px', width: '100%', paddingRight: '4px' }}>
                
                {/* 1. PARTILHA (🔗) */}
                <button
                  type="button"
                  onClick={partilharLiveReal}
                  style={{ pointerEvents: 'auto', backgroundColor: '#00F0FF', border: 'none', borderRadius: '50%', width: '35px', height: '35px', fontSize: '15px', cursor: 'pointer', boxShadow: '0 0 10px rgba(0, 240, 255, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  title="Partilhar Live"
                >
                  🔗
                </button>

                {/* 2. TAP TAP (🔥 / 📣) */}
                <button 
                  type="button"
                  onClick={async (e) => {
                    e.stopPropagation();
                    try {
                      const { doc: fDoc, updateDoc: fUpdateDoc, increment } = await import('firebase/firestore');
                      if (!idCanalEfetivo) return;

                      if (euPertencoAClaque && !metaClaqueAtingida) {
                        await fUpdateDoc(fDoc(db, "lives_activas", idCanalEfetivo), { tapsClaque: increment(10) });
                      } else {
                        const cliquesNovos = (window.acumuladorTaps || 0) + 1;
                        window.acumuladorTaps = cliquesNovos;
                        if (window.acumuladorTaps >= 10) {
                          window.acumuladorTaps = 0;
                          await fUpdateDoc(fDoc(db, "lives_activas", idCanalEfetivo), { totalTapTaps: increment(10) });
                        }
                      }
                    } catch (err) { console.error(err); }
                  }}
                  style={{ 
                    pointerEvents: 'auto', background: '#000', 
                    color: (euPertencoAClaque && !metaClaqueAtingida) ? '#00E5FF' : '#FF007F', 
                    border: (euPertencoAClaque && !metaClaqueAtingida) ? '2px solid #00E5FF' : '2px solid #FF007F', 
                    borderRadius: '50%', width: '35px', height: '35px', fontSize: '15px', cursor: 'pointer', 
                    boxShadow: (euPertencoAClaque && !metaClaqueAtingida) ? '0 0 12px #00E5FF' : '0 0 10px rgba(255, 0, 127, 0.4)', 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '900' 
                  }}
                  title="Esmagar Cliques de Suporte"
                >
                  {(euPertencoAClaque && !metaClaqueAtingida) ? "📣" : "🔥"}
                </button>

                {/* 3. TREVO (🍀) */}
                <button
                  type="button"
                  onClick={() => {
                    setMostrarCadernetaLive(true);
                    if (typeof setMostrarPresentes === 'function') setMostrarPresentes(false);
                  }}
                  style={{ backgroundColor: 'rgba(0,0,0,0.6)', border: '2px solid #FFD700', width: '35px', height: '35px', boxSizing: 'border-box', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', cursor: 'pointer', boxShadow: '0 0 12px rgba(255,215,0,0.3)' }}
                  title="Caderneta do Canal"
                >
                  🍀
                </button>

                {/* 4. CAIXA AMARELA (🎁) */}
                <button 
                  type="button"
                  onClick={() => { if (typeof setMostrarPresentes === 'function') setMostrarPresentes(true); }}
                  style={{ background: 'linear-gradient(135deg, #FF8C00 0%, #FF4500 100%)', border: 'none', width: '35px', height: '35px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 0 10px rgba(255, 69, 0, 0.4)', fontSize: '15px' }}
                >
                  🎁
                </button>

            {/* 5. LUCKYS RAIO (⚡) */}
                <button
                  type="button"
                  onClick={() => {
                    setTipoMenuAtivo("luckys");
                    setMostrarMenuLuckys(true); // 🔥 Correção Crítica: Abre o modal diretamente pulando a seleção inútil!
                    if (typeof setMostrarPresentes === 'function') setMostrarPresentes(false);
                  }}
                  style={{ 
                    cursor: 'pointer', 
                    fontSize: '15px', 
                    backgroundColor: 'rgba(255, 215, 0, 0.2)', 
                    width: '35px', 
                    height: '35px', 
                    borderRadius: '50%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    border: '2px solid #FFD700', 
                    boxShadow: '0 0 12px rgba(255, 215, 0, 0.5)',
                    color: '#FFD700',
                    fontWeight: '900'
                  }}
                  title="Menu de Luckys"
                >
                  ⚡
                </button>

                {/* 🚀 6. BOLINHA ROSA DE COMBOS — ENVIOS RÁPIDOS EM RAJADA (ESTILO ALII) */}
                {mostrarBolinhaRosa && comboPresenteAtivo && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', animation: 'bounceIn 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)' }}>
                    <button
                      type="button"
                                onClick={async (e) => {
              e.stopPropagation();

              // 🛡️ Tranca Regulamentar Suprema contra auto-doação no sinal de vídeo
              if (auth.currentUser?.uid === idCanalEfetivo) return;

              // 🎯 ALINHAMENTO IDÊNTICO ÀS SALAS: Extrai rigorosamente do item em cache na frame
              const passoComboReal = comboPresenteAtivo.quantidade || quantidadeSelecionada || 1;
              const proximonumeroCombo = (contagemComboCliques || 0) + passoComboReal;

              // 1. Atualiza imediatamente o contador interno da bolinha rosa
              setContagemComboCliques(proximonumeroCombo);

              // 2. Sincroniza imediatamente o letreiro néon central com o mesmo valor da bolinha
              setListaAvisosFeed(prev => prev.map(item =>
                item.uidRemetente === meuId
                  ? { ...item, quantidadeCombo: proximonumeroCombo }
                  : item
              ));

              // 3. Dispara a transação com a quantidade atómica trancada por frame
              const alvoFinal = comboDestinatarioAtivo || { uid: idCanalEfetivo, nome: "Streamer" };
              await processarEnvioPresente({
                ...comboPresenteAtivo,
                quantidade: passoComboReal,
                tipo: comboPresenteAtivo.tipo || comboPresenteAtivo.tipoPresente || 'lucky',
                tipoPresente: comboPresenteAtivo.tipo || comboPresenteAtivo.tipoPresente || 'lucky'
              }, alvoFinal);

              // 4. Reinicia o relógio de 3 segundos mantendo o temporizador limpo das Lives
              if (window.timerComboLive) clearTimeout(window.timerComboLive);
              window.timerComboLive = setTimeout(() => {
                setMostrarBolinhaRosa(false);
                setContagemComboCliques(0);
              }, 3000);
            }}

                      style={{
                        width: '35px',
                        height: '35px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #FF007F 0%, #FF66B2 100%)',
                        border: '2px solid #FFF',
                        boxShadow: '0 0 10px #FF007F, inset 0 0 4px rgba(255,255,255,0.6)',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '15px',
                        color: '#FFF',
                        fontWeight: '950',
                        pointerEvents: 'auto',
                        WebkitTapHighlightColor: 'transparent'
                      }}
                    >
                      💖
                    </button>
                    <span style={{
                      color: '#FF007F',
                      fontSize: '13px',
                      fontWeight: '950',
                      fontStyle: 'italic',
                      textShadow: '1px 1px 2px #000, 0 0 4px #FFF',
                      fontFamily: 'system-ui, sans-serif'
                    }}>
                      x{contagemComboCliques}
                    </span>
                  </div>
                )}

              </div>
            </>
          ) : (

            /* SE FOR O DONO DA LIVE: O CHAT DE DIGITAR FICA TAPADO, E O MICROFONE OCUPA O LUGAR GLOBAL */
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', paddingBottom: '10px' }}>
              <button 
                type="button"
                onClick={async () => {
                  // A pista vem da sessão; o ref é só um atalho já preenchido.
                  const audioTrack = audioTrackRef.current || ligacao.sessao.audio;
                  if (!audioTrack) {
                    console.warn("Microfone ainda não está pronto.");
                    return;
                  }
                  try {
                    const novoEstado = !micAtivo;
                    // setMuted mantém a pista publicada (não dispara user-unpublished),
                    // por isso a câmara do anfitrião NÃO desaparece para os espetadores.
                    await audioTrack.setMuted(!novoEstado);
                    setMicAtivo(novoEstado);
                  } catch (erro) {
                    console.error("Erro ao controlar o microfone:", erro);
                  }
                }}
                style={{ backgroundColor: micAtivo ? '#39FF14' : '#FF3131', border: 'none', width: '45px', height: '45px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: micAtivo ? '0 0 15px rgba(57, 255, 20, 0.5)' : '0 0 15px rgba(255, 49, 49, 0.5)', fontSize: '20px' }}
              >
                {micAtivo ? "🎙️" : "🔇"}
              </button>

                          {/* BOTÃO DE CONSULTA DA CADERNETA EXCLUSIVO PARA O DONO DA LIVE */}
            <button
              onClick={() => {
                setMostrarCadernetaLive(true);
                if (typeof setMostrarPresentes === 'function') setMostrarPresentes(false);
              }}
              style={{
                backgroundColor: 'rgba(0,0,0,0.6)', border: '2px solid #FFD700',
                width: '45px', height: '45px', borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '20px', cursor: 'pointer', boxShadow: '0 0 15px rgba(255,215,0,0.4)',
                marginLeft: '10px'
              }}
              title="Consultar a minha Caderneta"
            >
              🍀
            </button>

          </div>
        )}
      </div>
                    
                {/* BOTÃO DE PARTILHA DO DONO: ANCORADO AO CANTO DIREITO (não fica colado ao microfone) */}
          {emLive && (
            <div style={{ position: 'absolute', bottom: '34px', left: 'calc(50% + 58px)', zIndex: 1000002 }}>
              <button
                type="button"
                onClick={partilharLiveReal}
                style={{
                  pointerEvents: 'auto',
                  backgroundColor: '#00F0FF',
                  border: 'none',
                  borderRadius: '50%',
                  width: '48px',
                  height: '48px',
                  fontSize: '20px',
                  cursor: 'pointer',
                  boxShadow: '0 0 15px rgba(0, 240, 255, 0.6)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                title="Partilhar Estádio"
              >
                🔗
              </button>
            </div>
          )}

        {/* BOTÕES LATERAIS DOS ESPETADORES: PARTILHA + TAP TAP (PILHA FUTURISTA ELEVADA) */}
                    {!true && (
            <>
              {/* 1. BOTÃO AZUL NÉON DE PARTILHA (TOPO DA PILHA) */}
              <div style={{ position: 'absolute', bottom: '210px', right: '15px', zIndex: 1000002 }}>
                <button
                  type="button"
                  onClick={partilharLiveReal}
                  style={{
                    pointerEvents: 'auto',
                    backgroundColor: '#00F0FF',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    fontSize: '18px',
                    cursor: 'pointer',
                    boxShadow: '0 0 10px rgba(0, 240, 255, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  title="Partilhar Live"
                >
                  🔗
                </button>
              </div>

              {/* 2. BOTÃO INTERATIVO DE TAP TAP (CENTRO DA PILHA) */}
              <div style={{ position: 'absolute', bottom: '155px', right: '15px', zIndex: 1000002 }}>
                <button 
                  onClick={async (e) => {
                    e.stopPropagation();
                    const cliquesNovos = (window.acumuladorTaps || 0) + 1;
                    window.acumuladorTaps = cliquesNovos;

                    if (window.acumuladorTaps >= 10) {
                      window.acumuladorTaps = 0;
                      try {
                        const { doc: fDoc, updateDoc: fUpdateDoc, increment } = await import('firebase/firestore');
                        if (idCanalEfetivo) {
                          await fUpdateDoc(fDoc(db, "lives_activas", idCanalEfetivo), {
                            totalTapTaps: increment(10)
                          });
                        }
                      } catch (erroTap) {
                        console.error("Erro ao computar rajada de Tap Tap:", erroTap);
                      }
                    }
                  }}
                  style={{ 
                    pointerEvents: 'auto',
                    background: '#000',
                    color: '#FF007F',
                    border: '2px solid #FF007F',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    fontSize: '18px',
                    cursor: 'pointer',
                    boxShadow: '0 0 10px rgba(255, 0, 127, 0.4)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  🔥
                </button>
              </div>

              {/* 3. BOTÃO EXCLUSIVO DE TAPS DA CLAQUE OFICIAL (BASE DA PILHA ELEVADA) */}
              {euPertencoAClaque && !metaClaqueAtingida && (
                <button
                  onClick={async (e) => {
                    e.stopPropagation();
                    try {
                      const { doc: fDoc, updateDoc: fUpdateDoc, increment: fIncrement } = await import('firebase/firestore');
                      if (idCanalEfetivo) {
                        await fUpdateDoc(fDoc(db, "lives_activas", idCanalEfetivo), {
                          tapsClaque: fIncrement(10)
                        });
                      }
                    } catch (errTap) {
                      console.error("Erro ao computar rajada da Claque:", errTap);
                    }
                  }}
                  style={{
                    position: 'absolute',
                    bottom: '265px', // Empilhado perfeitamente acima da partilha para nunca colidirem
                    right: '15px',
                    zIndex: 1000002,
                    pointerEvents: 'auto',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: '#000000',
                    color: '#00E5FF',
                    border: '2px solid #00E5FF',
                    fontSize: '16px',
                    cursor: 'pointer',
                    boxShadow: '0 0 15px #00E5FF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '900'
                  }}
                  title="Esmagar Taps da Claque! 📣"
                >
                  📣
                </button>
              )}
            </>
          )}

        {/* COMPONENTES DE JANELAS SUSPENSAS DO ESTÁDIO (BLOCO DO TOSHIBA) */}
        {mostrarJanelaRanking && (
          <JanelaRankingLive 
            aberto={mostrarJanelaRanking} 
            aoFechar={() => setMostrarJanelaRanking(false)} 
            aoClicar={(idUser) => abrirPerfilEspetador(idUser)}
            emLive={emLive} 
            dadosUtilizador={dadosUtilizador} 
            db={db} 
            auth={auth} 
            idCanalLive={idCanalEfetivo}
          />
        )}

        {/* JANELA SUSPENSA DA LISTA DE ESPETADORES ONLINE EM VIDRO PREMIUM */}
        {mostrarListaOnline && (
          <div style={{ 
            position: 'fixed', bottom: 0, left: 0, width: '100%', height: '50vh', 
            background: 'linear-gradient(135deg, rgba(5, 5, 5, 0.85) 0%, rgba(5, 5, 5, 0.65) 100%)',
            backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)',
            zIndex: 1000030, padding: '20px', boxSizing: 'border-box', display: 'flex', 
            flexDirection: 'column', borderTop: '2px solid #39FF14', borderTopLeftRadius: '20px', 
            borderTopRightRadius: '20px', boxShadow: '0 -5px 25px rgba(57, 255, 20, 0.25)' 
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <h3 style={{ color: 'white', margin: 0, fontWeight: '900', fontSize: '15px', letterSpacing: '0.5px' }}>BANCADAS DO ESTÁDIO 🏟️</h3>
              <button onClick={() => setMostrarListaOnline(false)} style={{ background: 'rgba(255,255,255,0.1)', color: 'white', border: 'none', borderRadius: '50%', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' }}>✕</button>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: '10px 0' }}>
              {espetadoresDetalhados.length > 0 ? espetadoresDetalhados.map(espetador => (
                <div key={espetador.userId} style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px', borderBottom: '1px solid rgba(255,255,255,0.06)', paddingBottom: '10px' }}>
                  <img
                    src={espetador.foto || '/hero.png'}
                    onClick={() => abrirPerfilEspetador(espetador.userId)}
                    alt="Perfil"
                    style={{ width: '40px', height: '40px', borderRadius: '50%', border: '2px solid #39FF14', cursor: 'pointer', objectFit: 'cover', boxShadow: '0 2px 8px rgba(57,255,20,0.2)' }}
                  />

                  <span
                    onClick={() => abrirPerfilEspetador(espetador.userId)}
                    style={{ color: 'white', fontWeight: 'bold', fontSize: '14px', cursor: 'pointer' }}
                  >
                    {espetador.nome}
                  </span>

                  {/* BOTÃO EXPULSAR: SÓ NO ECRÃ DO DONO DA LIVE (HOST) */}
                  {emLive && espetador.userId !== auth.currentUser?.uid && (
                    <button
                      onClick={async (e) => {
                        e.stopPropagation();
                        if (window.confirm(`Tens a certeza que queres expulsar o ${espetador.nome}? ⚽🟥`)) {
                          try {
                            const { doc: fDoc, setDoc: fSetDoc, serverTimestamp: fTimestamp, deleteDoc: fDeleteDoc } = await import('firebase/firestore');
                            // Blindagem de consistência: amarra a rota de segurança ao canal efetivo mapeado em tempo real
                            const canalAlvoSeguro = idCanalEfetivo || auth.currentUser?.uid;

                            if (!canalAlvoSeguro) return;

                            // 1. BLACKLIST: bane o UID nesta live para que NÃO possa voltar a entrar
                            await fSetDoc(fDoc(db, "lives_activas", canalAlvoSeguro, "banidos", espetador.userId), {
                              banido: true,
                              excluidoEm: fTimestamp()
                            });

                            // 2. EXPULSÃO IMEDIATA: remove-o das bancadas (volta ao feed pelo sensor de banidos)
                            await fDeleteDoc(fDoc(db, "lives_activas", canalAlvoSeguro, "assistindo", espetador.userId));
                            alert("Utilizador banido e expulso com sucesso! 🟥");
                          } catch (errBan) {
                            console.error("Erro ao processar expulsão na live:", errBan);
                          }
                        }
                      }}
                      style={{ marginLeft: 'auto', backgroundColor: '#FF3131', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '8px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 0 8px rgba(255, 49, 49, 0.3)', textTransform: 'uppercase' }}
                    >
                      EXPULSAR
                    </button>
                  )}
                </div>
              )) : (
                <p style={{ color: '#888', fontSize: '13px', textAlign: 'center', marginTop: '30px' }}>Apenas tu estás nas bancadas. 🏆</p>
              )}
            </div>
          </div>
        )}
        </div>
      </div>

                {/* EXIBIÇÃO UNIFICADA: STICKERS E VÍDEOS PREMIUM COM CHROMA KEY E SOM */}
      {(videoCromoAtivo || presenteAtivo?.url) && (
        <div style={{
          position: 'fixed',
          inset: 0,
          zIndex: 99999,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'transparent',
          pointerEvents: 'none'
        }}>
                    {/* Mensagem Néon Superior (REESTRUTURADA PARA O TOPO DO ESTÁDIO) */}
          {(avisoCromo || presenteAtivo?.texto) && (
            <div style={{
              position: 'absolute',
              top: '95px', // 🚀 DESLOCADO PARA O TOPO: Fica alinhado mesmo abaixo dos letreiros deslizantes!
              left: '50%',
              transform: 'translateX(-50%) scale(1.02)', // Mantém a centralização horizontal impecável
              background: 'linear-gradient(135deg, #000 0%, #111 100%)',
              border: '2px solid #39FF14',
              borderRadius: '20px',
              padding: '8px 18px', // Ligeiramente mais compacto para não abafar o topo
              textAlign: 'center',
              boxShadow: '0 0 15px #39FF14, inset 0 0 8px rgba(57,255,20,0.4)',
              zIndex: 100000,
              width: '90%', // Garante boa leitura em ecrãs mais estreitos
              maxWidth: '340px',
              boxSizing: 'border-box'
            }}>
              <span style={{ color: '#FFF', fontSize: '11px', fontWeight: '950', letterSpacing: '0.5px', textTransform: 'uppercase', display: 'block' }}>
                {avisoCromo || presenteAtivo?.texto}
              </span>
            </div>
          )}

      {/* MOTOR DE RENDERIZAÇÃO INTELIGENTE (SUPORTE HÍBRIDO MP4 CHROMA KEY + WEBM ALFA TRANSPARENTE) */}
          {(() => {
            const mediaUrl = videoCromoAtivo || presenteAtivo?.url || "";

            // 💍 PRESENTES SEM FUNDO: se o presente já tem versão recortada em
            // assets/presentes/transparentes/, toca essa. Reconhece-se pelo nome do
            // vídeo antigo, que é o que chega pelo Firestore — quem envia e quem
            // recebe veem o mesmo. Os que ainda não foram recortados seguem abaixo.
            const semFundo = videoSemFundo(mediaUrl);
            if (semFundo) {
              return (
                <PresenteTransparente
                  key={mediaUrl + (presenteAtivo?.chave || '')}
                  src={semFundo}
                  tamanho={300}
                  aoTerminar={() => {
                    terminarPresente();
                  }}
                />
              );
            }
            
                        // 🚀 ESTADO A: Se for um vídeo WEBM transparente ou se for o Anel de Campeão (Ignora o Canvas e tranca as sombras!)
            if (String(mediaUrl).includes('.webm')) {
              return (
                <div style={{ position: 'relative', width: '300px', height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <video
                    id="video_player_live_premium_webm"
                    src={mediaUrl}
                    autoPlay
                    playsInline
                    style={{ 
                      width: '100%', 
                      height: '100%', 
                      objectFit: 'contain',
                      backgroundColor: 'transparent',
                      // 🎭 EFEITO ESFUMADO PREMIUM: Suaviza perfeitamente a base e as bordas no ecrã
                      WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 75%, rgba(0,0,0,0) 98%)',
                      maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 75%, rgba(0,0,0,0) 98%)'
                    }}
                    ref={(videoEl) => {
                      if (!videoEl) return;
                      // 🔊 LIBERTA O SOM REAL NATIVO: Liberta a música VIP original em volume máximo
                      try {
                        videoEl.muted = false;
                        videoEl.volume = 1.0;
                        videoEl.play().catch(() => {});
                      } catch (errAudio) {
                        console.log("Aguardando interação para som nativo WebM:", errAudio);
                      }
                    }}
                    // ⏱️ DURAÇÃO DINÂMICA SUPREMA: Fecha a animação no milésimo de segundo em que o ficheiro termina
                    onEnded={() => {
                      terminarPresente();
                      console.log("🏆 Presente WebM concluído nativamente com sucesso!");
                    }}
                  />
                </div>
              );
            }

            // 🟢 ESTADO B: Se for um vídeo MP4 antigo (Usa o motor de processamento de Canvas)
            if (String(mediaUrl).includes('.mp4')) {
              return (
                <div style={{ position: 'relative', width: '300px', height: '300px' }}>
                  {/* Canvas que processa e remove o fundo VERDE em tempo real */}
                  <canvas
                    ref={(canvas) => {
                      if (!canvas) return;
                      const video = document.getElementById('video_player_live_premium');
                      if (!video) return;
                      const ctx = canvas.getContext('2d');
                      let frameId;
                      
                      const limparVerde = () => {
                        if (video.paused || video.ended) return;
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                        const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                        const len = imgData.data.length;
                                               
                        for (let i = 0; i < len; i += 4) {
                          const r = imgData.data[i];
                          const g = imgData.data[i+1];
                          const b = imgData.data[i+2];
                          
                          if (g > 55 && g > r * 1.15 && g > b * 1.15) {
                            imgData.data[i+3] = 0;
                          }
                        }

                        ctx.putImageData(imgData, 0, 0);
                        frameId = requestAnimationFrame(limparVerde);
                      };
                      
                      video.addEventListener('play', limparVerde);
                      return () => cancelAnimationFrame(frameId);
                    }}
                    width={480}
                    height={480}
                    style={{ 
                      backgroundColor: 'transparent',
                      width: '100%', 
                      height: '100%', 
                      objectFit: 'contain',
                      WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 70%, rgba(0,0,0,0) 95%)',
                      maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 70%, rgba(0,0,0,0) 95%)'
                    }}
                  />
                  <video
                    id="video_player_live_premium"
                    src={mediaUrl}
                    autoPlay
                    playsInline
                    style={{ display: 'none' }}
                    ref={(videoEl) => {
                      if (!videoEl) return;
                      
                      const canvas = videoEl.previousSibling;
                      if (canvas && videoEl.dataset.limpo !== '1') {
                        videoEl.dataset.limpo = '1';
                        const ctx = canvas.getContext('2d');
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                      }

                      try {
                        videoEl.muted = false;
                        videoEl.volume = 1.0;
                        
                        if (!videoEl.paused && canvas) {
                          const event = new Event('play');
                          videoEl.dispatchEvent(event);
                        }
                        
                        videoEl.play().catch(() => {});
                      } catch (errAudio) {
                        console.log("Aguardando interação para som nativo:", errAudio);
                      }
                    }}
                    onEnded={() => {
                      terminarPresente();
                      console.log("🏆 Vídeo e áudio concluídos nativamente até ao fim!");
                    }}
                  />
                </div>
              );
            }

            // 🍀 ESTADO C: Se for um cromo/sticker PNG original, renderiza a imagem com brilho desportivo
            return (
              <img 
                src={mediaUrl} 
                alt="Cromo Premiado"
                style={{ 
                  width: '180px', 
                  height: '180px', 
                  objectFit: 'contain',
                  backgroundColor: 'transparent',
                  filter: 'drop-shadow(0 0 15px #FFD700)',
                  animation: 'bounce 0.5s ease infinite alternate'
                }} 
              />
            );
          })()}
        </div>
      )}

      {/* GAVETA DA CADERNETA DO STREAMER EM DIRETO (60VH EM VIDRO FOSCO COM O TEU FUNDO AUDIO) */}
      {mostrarCadernetaLive && (
        <div style={{ 
          position: 'absolute', bottom: 0, left: 0, right: 0, height: '60vh', 
          // 🎨 INJETADO O TEU FUNDO AUDIO AZUL NÉON VIBRANTE COM EFEITO VIDRO FOSCO PREMIUM
          background: `url(${imgfundoAudio}) center/cover no-repeat`, 
          backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', 
          borderTop: '2px solid #FFD700', borderTopLeftRadius: '25px', borderTopRightRadius: '25px', 
          zIndex: 9999, display: 'flex', flexDirection: 'column', boxSizing: 'border-box', padding: '15px',
          boxShadow: '0 -8px 32px rgba(0, 0, 0, 0.5), 0 0 15px rgba(255, 215, 0, 0.15)'
        }}>

          {/* TOPO DA GAVETA */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(255,255,255,0.06)', paddingBottom: '10px' }}>
            <span style={{ color: '#FFD700', fontSize: '13px', fontWeight: '900', letterSpacing: '0.5px' }}>
              CADERNETA DO CANAL 🍀⚽
            </span>
            <button 
              onClick={() => setMostrarCadernetaLive(false)}
              style={{ background: 'rgba(255,255,255,0.05)', border: 'none', borderRadius: '50%', color: '#FFD700', fontWeight: 'bold', fontSize: '14px', width: '26px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
            >
              ✕
            </button>
          </div>

    {/* GRELHA WITH SCROLL FLUIDO PARA A CLAQUE VER E COMPRAR - AJUSTADA EM COLUNAS COMPACTAS */}
          <div style={{ flex: 1, overflowY: 'auto', marginTop: '10px', paddingBottom: '20px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px' }}> {/* Encolhido o espaço entre os cards */}
              {cromosCadernetaLive.map((cromo) => {
              const donoJaTem = cromosDesbloqueadosIds.includes(String(cromo.cromoNumero));

                return (
                  <div
                    key={cromo.id}
                                        onClick={() => {
                      if (cromo.emBreve || donoJaTem || emLive) return;
                      // Clique validado na base de dados: fecha a gaveta IMEDIATAMENTE
                      // para uma transição suave antes de processar o presente.
                      setMostrarCadernetaLive(false);
                      dispararPresente(cromo.preco, cromo.nome, cromo.icone, 'trevo');
                    }}
                    style={{
                      background: donoJaTem ? 'linear-gradient(135deg, rgba(57, 255, 20, 0.08) 0%, rgba(0, 0, 0, 0.4) 100%)' : 'rgba(5, 5, 5, 0.65)', // Fundo escurecido para dar contraste sobre o azul néon
                      border: donoJaTem ? '1px solid #39FF14' : '1px solid rgba(255, 255, 255, 0.05)',
                      borderRadius: '12px', 
                      padding: '6px 2px', // Compactado de 10px para 6px para o texto respirar verticalmente
                      textAlign: 'center', 
                      cursor: cromo.emBreve || donoJaTem || emLive ? 'default' : 'pointer',
                      position: 'relative', 
                      opacity: cromo.emBreve ? 0.3 : 1,
                      boxShadow: donoJaTem ? '0 4px 12px rgba(57,255,20,0.1)' : 'none',
                      boxSizing: 'border-box'
                    }}
                  >
                    <span style={{ position: 'absolute', top: '4px', left: '6px', color: donoJaTem ? '#39FF14' : '#555', fontSize: '8px', fontWeight: '900' }}>
                      #{cromo.cromoNumero}
                    </span>

                    <img 
                      src={cromo.icone} 
                      alt={cromo.nome} 
                      style={{ 
                        width: '34px', // Encolhido de 40px para 34px como a primeira coluna do teu print anterior
                        height: '34px', 
                        objectFit: 'contain', 
                        margin: '6px auto 3px auto', 
                        display: 'block', 
                        filter: donoJaTem ? 'none' : 'grayscale(100%) opacity(35%)' 
                      }} 
                    />

                    <span style={{ 
                      color: donoJaTem ? '#FFF' : '#666', 
                      fontSize: '9px', // Reduzido de 10px para 9px para trancar nomes compridos em uma só linha
                      fontWeight: 'bold', 
                      display: 'block', 
                      overflow: 'hidden', 
                      textOverflow: 'ellipsis', 
                      whiteSpace: 'nowrap', 
                      width: '100%',
                      padding: '0 2px',
                      boxSizing: 'border-box'
                    }}>
                      {cromo.nome}
                    </span>

                    <span style={{ color: donoJaTem ? '#39FF14' : '#FFD700', fontSize: '8px', fontWeight: '900', display: 'block', marginTop: '1px' }}>
                      {donoJaTem ? '✓ DOADO' : `🪙 ${cromo.preco}`}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      )}

    {/* GAVETA DE PRESENTES MP4 (OTIMIZADA PARA 3 COLUNAS E FUNDO AZUL DAS SALAS) */}
      {mostrarPresentes && (
        <div style={{ 
          position: 'absolute', bottom: 0, left: 0, right: 0, 
          // 🎨 ALTERADO PARA O FUNDO AZUL DAS SALAS DE ÁUDIO (MUITO MAIS VISÍVEL)
          background: `url(${imgfundoAudio}) center/cover no-repeat`, 
          backdropFilter: 'blur(25px)', WebkitBackdropFilter: 'blur(25px)', 
          borderTop: '2px solid #39FF14', borderTopLeftRadius: '20px', borderTopRightRadius: '20px', 
          zIndex: 100, padding: '16px', display: 'flex', flexDirection: 'column', gap: '14px', 
          boxShadow: '0 -8px 32px rgba(0, 0, 0, 0.6), 0 0 15px rgba(57, 255, 20, 0.15)',
          boxSizing: 'border-box'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '8px' }}>
            <span style={{ fontSize: '12px', color: '#FFF', fontWeight: 'bold' }}>⚽ Teu Saldo: <b style={{ color: '#39FF14' }}>{saldoBolas}</b> Bolas</span>
            <button onClick={() => setMostrarPresentes(false)} style={{ backgroundColor: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '12px', color: '#FFF', padding: '4px 10px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer' }}>Fechar ✕</button>
          </div>
          
      {/* 📊 GRELHA COMPACTA DE 3 COLUNAS - AJUSTADA PARA NOMES COMPRIDOS */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(3, 1fr)', 
            gap: '6px', 
            maxHeight: '240px', 
            overflowY: 'auto', 
            padding: '4px 2px' 
          }}>
            {PRESENTES_REAIS_LIVECAMPO.map((pres) => (
              <div 
                key={pres.id}
                onClick={() => dispararPresente(pres.preco, pres.nome, pres.video, 'normal')}
                style={{ 
                  background: 'rgba(5, 5, 5, 0.65)', 
                  border: '1px solid rgba(255,255,255,0.08)', 
                  borderRadius: '12px', 
                  padding: '6px 2px', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center', 
                  cursor: 'pointer', 
                  gap: '2px', 
                  transition: 'transform 0.15s', 
                  boxSizing: 'border-box' 
                }}
              >
                {/* FOTO E IDENTIFICAÇÃO DO TEU PRESENTE REAL */}
                <img src={pres.icone} alt={pres.nome} style={{ width: '34px', height: '34px', objectFit: 'contain' }} />
                
                <span style={{ 
                  fontSize: '9px', 
                  fontWeight: 'bold', 
                  color: '#FFF', 
                  marginTop: '1px', 
                  textAlign: 'center', 
                  overflow: 'hidden', 
                  textOverflow: 'ellipsis', 
                  whiteSpace: 'nowrap', 
                  width: '100%',
                  padding: '0 2px',
                  boxSizing: 'border-box'
                }}>
                  {pres.nome}
                </span>
                
                <span style={{ fontSize: '8px', color: '#39FF14', fontWeight: '950', marginTop: '1px' }}>
                  🪙 {pres.preco}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* CONFETTI EXPLOSIVO: dispara no exato momento em que a Claque Oficial atinge 5000 taps */}
      {mostrarConfettiClaque && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 1000010, pointerEvents: 'none', overflow: 'hidden' }}>
          {pecasConfettiRef.current.map((peca, idx) => (
            <span
              key={idx}
              style={{
                position: 'absolute',
                top: '-20px',
                left: `${peca.esquerda}%`,
                width: `${peca.tamanho}px`,
                height: `${peca.tamanho}px`,
                backgroundColor: peca.cor,
                boxShadow: `0 0 6px ${peca.cor}`,
                transform: `rotate(${peca.rotacao}deg)`,
                animation: `confettiQueda ${peca.duracao}s linear ${peca.atraso}s forwards`
              }}
            />
          ))}
          <div style={{ position: 'absolute', top: '30%', left: 0, right: 0, textAlign: 'center' }}>
            <span style={{ color: '#FFD700', fontSize: '20px', fontWeight: '950', textShadow: '0 0 10px #FFD700, 0 0 20px rgba(255,215,0,0.6)', letterSpacing: '1px' }}>
              📣 CLAQUE OFICIAL ATINGIU 5000 TAPS! 🎉
            </span>
          </div>
        </div>
        
      )}
    </div>
  );
}

export default LiveCampo;

